import React, { Component } from "react";
import moment from "moment";
import TopHeader from "../template/TopHeader";
import { connect } from "react-redux";
import {
  bookingActions,
  hairdresserActions,
  paymentActions,
  userActions,
} from "../../_actions";
import { voucherActions } from "../../_actions/voucher.actions";

import siteSetting from "../../config/env";
import dateFormat from "dateformat";
// import Checkout from "../hairdresserBooking/Checkout";
import Checkout from "./Checkout";
import { bookingService, paymentService } from "../../_services";
import { loadStripeTerminal } from "@stripe/terminal-js";
import CheckoutProduct from "./CheckoutProduct";
import CheckoutService from "./CheckoutService";
import CheckoutVoucher from "./CheckoutVoucher";
import { productAction } from "../../_actions/product.action";
import toast from '../shared/Toast';
import { FindVoucherModal, RedeemVoucherModal } from "./Checkout";
import PaymentLinkModal from "../payment/PaymentLinkModal";
import { hairdresserService } from "../../_services";
import { can as canMoney } from '../permissions/access';



var _ = require("lodash");

let userIdHolder = [];
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function getslotTime(time) {
  let hr = parseInt(time / 60);
  let min = time - hr * 60;
  return (
    (hr <= 9 ? "0" + hr : hr) +
    ":" +
    (min == 0 ? "00" : min <= 9 ? "0" + min : min) +
    ":00"
  );
}

var terminal;

// loadStripeTerminal().then(function (StripeTerminal) {
//   terminal = StripeTerminal.create({
//     onFetchConnectionToken: fetchConnectionToken,
//     onUnexpectedReaderDisconnect: unexpectedDisconnect,
//   });
// });

function fetchConnectionToken() {
  let self = this;
  return paymentService.fetchConnectionToken().then(function (res) {
    console.log("fetchConnectionToken res", res.data);
    return res.data.responseData.result.secret;
  });
}

function unexpectedDisconnect() {
  console.timeLog("disconnect@@@@@@@@");
}

class InstantCheckout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookingDate: new Date(),
      selectSlot: "",
      showOptionsModal: false,
      showTipModal: false,
      latitude: siteSetting.default_latitude,
      longitude: siteSetting.default_longitude,
      hairdresserName: "",
      selectedService: [],
      finalBookingSlots: [],
      includeTimes: [],
      slotInfo: {},
      totalAmount: 0,
      prevPrice: 0,
      servicePrice: 0,
      totalTime: 0,
      hairdresserId: "",
      priceError:'',
      selectedClientId: "",
      selectedClient: {},
      isSaveBooking: 0,
      bookingSlots: [],
      paymentType: "",
      isBookingAllowed: false,
      searchKey: "",
      bookingType: "past", //upcoming
      pendingAmount: 0,
      transaction: [],
      paymentAmount: 0,
      totalPaymentAmount: 0,
      isCheckout: 1,
      userId: "",
      isInvoice: 0,
      currencySymbol: this.props?.user?.userInfo?.hairdresser?.currencySymbol || "£",
      bookingId: "",
      isServiceEdit: false,
      transactions: [],
      invoiceNumber: 0,
      selectedPaymentType: null,
      selectedAmount: "",
      oldTransaction: [],
      serviceHardresserList: [],
      checkOutAmountType: true,
      selectedFixedAmount: 0,
      isPaymentComplete: 0,
      priceErrorStatus:true,
      isMobileEnableState: true,
      locationId: "",
      selectedCardReader: {},
      paymentIntents: {},
      isCardReaderConnected: false,
      isShowConnectionLoader: false,
      registrationCode: "",
      showDiscoversModal: false,
      isCheckoutPayment: false,
      payoutError: "",
      cardReaderConnectError: "",
      label: "",
      tipAmount: 0,
      showService: false,
      selectedServices: [],
      allServices: [],
      fromServices: [],
      endTimeSlot: new Date(),
      hairDresserName: "",
      selectedTime: "",
      newStartTime: "",
      showPaymentLinkModal: false,
      paymentLinkData: null,
      pendingVoucherRedemption: null,
      productList: [],
      serviceList: [],
      checkoutSelectedItems:[],
      staffList:[],
      selectedStaff:null,
      selectedClientRecord:null,
      selectedTotalAmount: 0,
      isTrStart:false,
      // Voucher redemption state
      showFindVoucherModal: false,
      showRedeemVoucherModal: false,
      foundVoucher: null,
      voucherCode: '',
      paymentMethods: {
        cash: true,
        card: true,
        other: true,
        beuCardReaders: true,
        cardOnFile: true,
        paymentLink: true,
        klarna: false,
        clearPay: false,
        vouchers: true
      },
      voucherRedemptionAmount: 0
    };

    this.editCheckoutBooking = this.editCheckoutBooking.bind(this);
    this.resetBooking = this.resetBooking.bind(this);
    this.checkoutBooking = this.checkoutBooking.bind(this);
    this.onChanged = this.onChanged.bind(this);
    this.staffMemberHandler = this.setSelectedProduct.bind(this);
    this.setSelectedClient= this.setSelectedClient.bind(this);
    this.setSelectedVoucher = this.setSelectedVoucher.bind(this);
    this.calculateCheckoutItem = this.calculateCheckoutItem.bind(this);
    this.completeSale = this.completeSale.bind(this);
    // this.completeSaleForCardReader = this.completeSaleForCardReader.bind(this);
    this.checkout = this.checkout.bind(this);
    this.createBooking = this.createBooking.bind(this);
    this.updatedCheckOut = this.updatedCheckOut.bind(this);
    this.changeItemPrice = this.changeItemPrice.bind(this);
    this.updateNewEditAmount = this.updateNewEditAmount.bind(this);
    
    // Voucher redemption methods
    this.openFindVoucherModal = this.openFindVoucherModal.bind(this);
    this.closeFindVoucherModal = this.closeFindVoucherModal.bind(this);
    this.findVoucher = this.findVoucher.bind(this);
    this.closeRedeemVoucherModal = this.closeRedeemVoucherModal.bind(this);
    this.redeemVoucher = this.redeemVoucher.bind(this);
    this.applyVoucherToCheckout = this.applyVoucherToCheckout.bind(this);
    this.fetchPaymentMethods = this.fetchPaymentMethods.bind(this);
    
    // Payment Link methods
    this.createPaymentLink = this.createPaymentLink.bind(this);
    this.createKlarnaPaymentLink = this.createKlarnaPaymentLink.bind(this);
    this.createClearpayPaymentLink = this.createClearpayPaymentLink.bind(this);
    this.handlePaymentComplete = this.handlePaymentComplete.bind(this);
    this.checkPaymentStatus = this.checkPaymentStatus.bind(this);
  }

// end get staff
  handleOptionModal = () =>
    this.setState({ showOptionsModal: !this.state.showOptionsModal });

  handleTipModal = () => {
    this.setState({
      showOptionsModal: false,
      showTipModal: !this.state.showTipModal,
    });
  };

  handleDiscoverModal = () => {
    this.setState({
      showDiscoversModal: true,
    });
  };

  handleClose = () => {
    this.setState({
      showDiscoversModal: false,
    });
  };

  // Fetch payment method settings
  fetchPaymentMethods() {
    const self = this;
    console.log('InstantCheckout - Fetching payment methods');
    
    hairdresserService.getPaymentMethods()
      .then(response => {
        console.log('InstantCheckout - Payment methods API response:', response.data);
        if (response.data && response.data.responseData && response.data.responseData.paymentMethods) {
          console.log('InstantCheckout - Payment methods loaded:', response.data.responseData.paymentMethods);
          self.setState({
            paymentMethods: response.data.responseData.paymentMethods
          }, () => {
            console.log('InstantCheckout - Payment methods state updated:', self.state.paymentMethods);
          });
        } else {
          console.warn('InstantCheckout - No payment methods found in response');
        }
      })
      .catch(error => {
        console.error('InstantCheckout - Error fetching payment methods:', error);
      });
  }

  // Voucher redemption methods
  openFindVoucherModal() {
    this.setState({ showFindVoucherModal: true });
  }

  closeFindVoucherModal() {
    this.setState({ showFindVoucherModal: false });
  }

  findVoucher(code) {
    const self = this;
    self.setState({ voucherCode: code });
    
    // Call the API to find the voucher by code
    this.props.dispatch(voucherActions.getVoucherByCode(code))
      .then(response => {
        if (response && response.data) {
          const voucher = response.data;
          self.setState({
            foundVoucher: voucher,
            showFindVoucherModal: false,
            showRedeemVoucherModal: true
          });
        } else {
          // Handle voucher not found
          toast.error("Voucher not found. Please check the code and try again.");
        }
      })
      .catch(error => {
        console.error("Error finding voucher:", error);
        toast.error("Error finding voucher. Please try again.");
      });
  }

  closeRedeemVoucherModal() {
    this.setState({
      showRedeemVoucherModal: false,
      foundVoucher: null,
      voucherRedemptionAmount: 0
    });
  }

  redeemVoucher(amount) {
    const self = this;
    const { foundVoucher } = self.state;
    
    if (!foundVoucher) {
      toast.error("No voucher found to redeem.");
      return;
    }

    // Validate amount
    const redemptionAmount = parseFloat(amount);
    if (isNaN(redemptionAmount) || redemptionAmount <= 0) {
      toast.error("Please enter a valid amount greater than 0.");
      return;
    }

    if (redemptionAmount > foundVoucher.remainingBalance) {
      toast.error(`Cannot redeem more than the remaining balance of ${foundVoucher.remainingBalance}.`);
      return;
    }

    // Update the voucher balance in the database
    const newBalance = foundVoucher.remainingBalance - redemptionAmount;
    const voucherId = foundVoucher._id;

    this.props.dispatch(voucherActions.updateVoucherBalance(voucherId, newBalance))
      .then(response => {
        if (response && response.success) {
          // Add the voucher payment to the transaction
          const transaction = {
            paymentType: 'Gift Card',
            paymentAmount: redemptionAmount,
            voucherId: voucherId,
            voucherCode: foundVoucher.code
          };

          // Add to transactions
          const updatedTransactions = [...self.state.transactions, transaction];
          
          // Update state
          self.setState({
            transactions: updatedTransactions,
            showRedeemVoucherModal: false,
            pendingAmount: Math.max(0, self.state.pendingAmount - redemptionAmount),
            voucherRedemptionAmount: redemptionAmount
          });

          toast.success(`Successfully redeemed ${redemptionAmount} from voucher.`);
        } else {
          toast.error("Failed to update voucher balance. Please try again.");
        }
      })
      .catch(error => {
        console.error("Error updating voucher balance:", error);
        toast.error("Error updating voucher balance. Please try again.");
      });
  }


  setSelectedCheckoutData(){
    let self = this;
    const selectedCheckOutArr = self.props?.selectedCheckoutList?.length>0?self.props?.selectedCheckoutList:[];
   
    console.log('setSelectedCheckoutData - selectedCheckOutArr:', selectedCheckOutArr);
    console.log('setSelectedCheckoutData - voucher items in list:', selectedCheckOutArr.filter(item => item.type === 'voucher').length);
    
    // Preserve the type of each checkout item
    const typedCheckoutItems = selectedCheckOutArr.map(item => {
      // Ensure the type property is preserved
      return {...item, type: item.type};
    });
    
    console.log('setSelectedCheckoutData - typedCheckoutItems:', typedCheckoutItems);
    console.log('setSelectedCheckoutData - voucher items in typedCheckoutItems:', typedCheckoutItems.filter(item => item.type === 'voucher').length);
    
    self.setState({
      checkoutSelectedItems: typedCheckoutItems,
      selectedStaff:selectedCheckOutArr[0]?.selectedStaff!==undefined?selectedCheckOutArr[0]?.selectedStaff:null,
      selectedClient:selectedCheckOutArr[0]?.selectedClient!==undefined?selectedCheckOutArr[0]?.selectedClient:null,
    }, () => {
      console.log('setSelectedCheckoutData - state updated with checkoutSelectedItems:', self.state.checkoutSelectedItems);
      console.log('setSelectedCheckoutData - voucher items in state:', self.state.checkoutSelectedItems.filter(item => item.type === 'voucher').length);
      
      // Call these methods in sequence, but ensure they don't change item types
      console.log('setSelectedCheckoutData - calling setSelectedProduct');
      this.setSelectedProduct();
      console.log('setSelectedCheckoutData - calling setSelectedClient');
      this.setSelectedClient();
      console.log('setSelectedCheckoutData - calling setSelectedService');
      this.setSelectedService();
      console.log('setSelectedCheckoutData - calling setSelectedVoucher');
      this.setSelectedVoucher();
      console.log('setSelectedCheckoutData - all methods called');
    })
  }

  setSelectedProduct(){
    let self = this;
    let dispatch = self.props.dispatch;
    let selectedProductData = self.props.selectCheckoutItem;

    console.log('setSelectedProduct - selectedProductData:', selectedProductData);
    console.log('setSelectedProduct - selectedCheckoutList:', self.props?.selectedCheckoutList);

    // Check if we're returning from client selection or voucher selection
    const fromClientSelection = self.props.location?.state?.fromClientSelection;
    const fromVoucherSelection = self.props.location?.state?.fromVoucherSelection;
    
    console.log('setSelectedProduct - fromClientSelection:', fromClientSelection);
    console.log('setSelectedProduct - fromVoucherSelection:', fromVoucherSelection);
    
    // If we're returning from client selection (but not voucher selection), don't update the item type
    if (fromClientSelection && !fromVoucherSelection) {
      console.log('setSelectedProduct - returning from client selection, not updating item type');
      return;
    }
    
    // If we're returning from voucher selection, we should continue to update the product
    if (fromVoucherSelection) {
      console.log('setSelectedProduct - returning from voucher selection, continuing to update product');
    }

    if(selectedProductData?._id !== undefined){
     let updatedList = self.props?.selectedCheckoutList.length>0?self.props?.selectedCheckoutList.map(item=>{
        console.log('setSelectedProduct - comparing item.id:', item?.id, 'with selectedProductData.indexId:', selectedProductData.indexId);
        
        // Only update the item if it's actually a product or if it's the specific item being updated
        if(item?.id===selectedProductData.indexId && !item.selectedService){
          console.log('setSelectedProduct - match found, updating item');
          item = {...item,...selectedProductData, type: 'product'};
        }
        // Preserve existing types
        else if (item.type === 'service' || item.selectedService) {
          item.type = 'service';
        } else if (item.type === 'product') {
          item.type = 'product';
        } else if (item.type === 'voucher') {
          item.type = 'voucher';
        }
        return item;
      }):[];

      console.log('setSelectedProduct - updatedList:', updatedList);

      dispatch(productAction?.selectedCheckoutList(updatedList));
      self.setState({
        checkoutSelectedItems: updatedList,
      },()=>{
        self.calculateCheckoutItem();
      })
    }
  }

  setSelectedClient(){
    let self = this;
    let selectedClientData = self.props.selectedClient;
    
    // Check if we're returning from client selection or voucher selection
    const fromClientSelection = self.props.location?.state?.fromClientSelection;
    const fromVoucherSelection = self.props.location?.state?.fromVoucherSelection;
    
    console.log('setSelectedClient - fromClientSelection:', fromClientSelection);
    console.log('setSelectedClient - fromVoucherSelection:', fromVoucherSelection);
    console.log('setSelectedClient - selectedClientData:', selectedClientData);
    
    if(selectedClientData?._id !== undefined){
      // Only update the client information without affecting the checkout items
      self.setState({
        selectedClient: selectedClientData
      }, () => {
        // Get the current checkout items
        const currentItems = [...self.state.checkoutSelectedItems];
        
        // Find the item that matches the indexId from the client selection
        const targetItem = currentItems.find(item => item.id === selectedClientData.indexId);
        
        console.log('setSelectedClient - targetItem:', targetItem);
        
        // Determine the correct type based on the current item's properties
        let correctType = 'service'; // Default to service
        
        if (targetItem) {
          // First check if the item has an explicit type
          if (targetItem.type) {
            correctType = targetItem.type;
          }
          // If no explicit type, determine based on properties
          else if (targetItem.selectedService) {
            correctType = 'service';
          } else if (targetItem._id || targetItem.retailPrice !== undefined) {
            correctType = 'product';
          } else if (targetItem.voucherPrice !== undefined || targetItem.voucherId) {
            correctType = 'voucher';
          }
          
          console.log('setSelectedClient - determined correctType:', correctType);
        }
        
        // Ensure all items maintain their original types
        const updatedItems = currentItems.map(item => {
          // If this is the item we're updating from client selection or voucher selection
          if ((fromClientSelection || fromVoucherSelection) && item.id === selectedClientData.indexId) {
            console.log('setSelectedClient - setting item type for item:', item.id, 'to', correctType);
            return { ...item, type: correctType };
          }
          // Otherwise, preserve the type based on the item's properties
          // If the item already has a type, preserve it
          else if (item.type) {
            return item;
          }
          // Otherwise determine type based on properties
          else if (item.selectedService) {
            return { ...item, type: 'service' };
          } else if (item._id || item.retailPrice !== undefined) {
            return { ...item, type: 'product' };
          } else if (item.voucherPrice !== undefined || item.voucherId) {
            return { ...item, type: 'voucher' };
          }
          // If we can't determine the type, keep the existing type
          return item;
        });
        
        // Log for debugging
        console.log('setSelectedClient - updatedItems after type preservation:', updatedItems);
        
        // Update the state with the type-preserved items
        self.setState({
          checkoutSelectedItems: updatedItems
        }, () => {
          // Then recalculate checkout items
          self.calculateCheckoutItem();
        });
      })
    }else{
      self.props.dispatch(productAction.selectedClient(siteSetting.noClientDAta));
      self.setState({
        selectedClient: siteSetting.noClientDAta,
      }, () => {
        // Ensure all items maintain their original types
        const updatedItems = self.state.checkoutSelectedItems.map(item => {
          // Always preserve the type of each item
          if (item.type === 'service' || item.selectedService) {
            return { ...item, type: 'service' };
          } else if (item.type === 'product') {
            return { ...item, type: 'product' };
          } else if (item.type === 'voucher') {
            return { ...item, type: 'voucher' };
          }
          // If no type is found but it has selectedService, it should be a service
          else if (item.selectedService) {
            return { ...item, type: 'service' };
          }
          return item;
        });
        
        // Update the state with the type-preserved items
        self.setState({
          checkoutSelectedItems: updatedItems
        }, () => {
          // Then recalculate checkout items
          self.calculateCheckoutItem();
        });
      })
    }
  }


  setSelectedVoucher(){
    let self = this;
    let dispatch = self.props.dispatch;
    let selectedVoucherData = self.props.selectCheckoutItem;

    console.log('setSelectedVoucher - selectedVoucherData:', selectedVoucherData);
    console.log('setSelectedVoucher - selectedCheckoutList:', self.props?.selectedCheckoutList);

    // Check if we're returning from client selection or voucher selection
    const fromClientSelection = self.props.location?.state?.fromClientSelection;
    const fromVoucherSelection = self.props.location?.state?.fromVoucherSelection;
    
    console.log('setSelectedVoucher - fromClientSelection:', fromClientSelection);
    console.log('setSelectedVoucher - fromVoucherSelection:', fromVoucherSelection);
    
    // If we're returning from client selection (but not voucher selection), don't update the item type
    if (fromClientSelection && !fromVoucherSelection) {
      console.log('setSelectedVoucher - returning from client selection, not updating item type');
      return;
    }
    
    // If we're returning from voucher selection, we should continue to update the voucher
    if (fromVoucherSelection) {
      console.log('setSelectedVoucher - returning from voucher selection, continuing to update voucher');
    }

    // Check if the selected item is actually a voucher
    if(selectedVoucherData?.type === 'voucher'){
      let updatedList = self.props?.selectedCheckoutList.length>0?self.props?.selectedCheckoutList.map(item=>{
        console.log('setSelectedVoucher - comparing item.id:', item?.id, 'with selectedVoucherData.indexId:', selectedVoucherData.indexId);
        
        // Only update the item if it's the specific item being updated and not a service
        if(item?.id===selectedVoucherData.indexId && !item.selectedService){
          console.log('setSelectedVoucher - match found, updating item');
          
          // Create a complete voucher item with all required properties
          const updatedItem = {
            ...item,
            ...selectedVoucherData,
            type: 'voucher',
            voucherName: selectedVoucherData.voucherName || selectedVoucherData.name || `${selectedVoucherData.currency || '£'}${selectedVoucherData.value || 0}`,
            voucherPrice: selectedVoucherData.voucherPrice || selectedVoucherData.value || 0,
            voucherCode: selectedVoucherData.voucherCode || selectedVoucherData.code || '',
            voucherType: selectedVoucherData.voucherType || 'standard',
            voucherDescription: selectedVoucherData.voucherDescription || '',
            currency: selectedVoucherData.currency || '£',
            value: selectedVoucherData.value || 0,
            name: selectedVoucherData.name || selectedVoucherData.voucherName || ''
            // Removed retailPrice property as it causes vouchers to be categorized as products
          };
          
          console.log('setSelectedVoucher - updated voucher item:', updatedItem);
          console.log('setSelectedVoucher - voucher properties:', Object.keys(updatedItem));
          return updatedItem;
        }
        // Preserve existing types
        else if (item.type === 'service' || item.selectedService) {
          item.type = 'service';
        } else if (item.type === 'product') {
          item.type = 'product';
        } else if (item.type === 'voucher') {
          item.type = 'voucher';
        }
        return item;
      }):[];

      console.log('setSelectedVoucher - updatedList:', updatedList);
      console.log('setSelectedVoucher - updatedList length:', updatedList.length);
      console.log('setSelectedVoucher - voucher items in list:', updatedList.filter(item => item.type === 'voucher').length);

      dispatch(productAction?.selectedCheckoutList(updatedList));
      self.setState({
        checkoutSelectedItems: updatedList,
      },()=>{
        console.log('setSelectedVoucher - state updated with checkoutSelectedItems:', self.state.checkoutSelectedItems);
        self.calculateCheckoutItem();
      })
    }
  }


  setSelectedService(){
    let self = this;
    let dispatch = self.props.dispatch;
    let selectedServiceData = self.props?.selectedService;
    let totalAmount=0;
    
    // Check if we're returning from client selection or voucher selection
    const fromClientSelection = self.props.location?.state?.fromClientSelection;
    const fromVoucherSelection = self.props.location?.state?.fromVoucherSelection;
    
    console.log('setSelectedService - fromClientSelection:', fromClientSelection);
    console.log('setSelectedService - fromVoucherSelection:', fromVoucherSelection);
    
    // If we're returning from client selection (but not voucher selection), don't update the item type
    if (fromClientSelection && !fromVoucherSelection) {
      console.log('setSelectedService - returning from client selection, not updating item type');
      return;
    }
    
    // If we're returning from voucher selection, we should continue to update the service
    if (fromVoucherSelection) {
      console.log('setSelectedService - returning from voucher selection, continuing to update service');
    }
    
    if(selectedServiceData?._id !== undefined){
     let updatedList = self.props?.selectedCheckoutList.length>0?self.props?.selectedCheckoutList.map(item=>{
      totalAmount += isNaN(item.servicePrice)?selectedServiceData?.servicePrice:item.servicePrice;
      
      // Only update the item if it's actually a service or if it's the specific item being updated
      if(item?.id===selectedServiceData.indexId && !item._id && !item.voucherPrice){
          console.log('setSelectedService - match found, updating item');
          // Update the service data
          item.selectedService = selectedServiceData;
          // Ensure the type is explicitly set to 'service'
          item.type = 'service';
      }
      // Preserve existing types
      else if (item.type === 'service' || item.selectedService) {
          item.type = 'service';
      } else if (item.type === 'product') {
          item.type = 'product';
      } else if (item.type === 'voucher') {
          item.type = 'voucher';
      }
      
      return item;
     }):[];
      
      dispatch(hairdresserActions.selectedService({}));
      dispatch(productAction?.selectedCheckoutList(updatedList));
      self.setState({
        selectedTotalAmount:totalAmount,
        totalAmount:totalAmount,
        selectedCheckoutList: updatedList,
        checkoutSelectedItems: updatedList, // Add this line to ensure state is properly updated
      },function (){
        self.calculateCheckoutItem();
      })
    }
  }

  componentDidMount() {
    var self = this;
    let pageStatus = 0;
    const { state } = this.props.location;
    console.log('check navigation tab 1',state);
    if (state) {
      const { pageLoadingStatus, fromClientSelection } = state;
      pageStatus = pageLoadingStatus!==undefined?pageLoadingStatus:0;

      // If we're returning from client selection, we don't want to clear the state
      if(pageLoadingStatus===1 && !fromClientSelection){
        // all redux clear here
   
        self.props.dispatch(hairdresserActions.selectedService({}));
        self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
        self.props.dispatch(bookingActions?.hairdresserNewBookingClient({})
        );
        self.props.dispatch(bookingActions?.selectHairdresserBookingDate({}));
        self.props.dispatch(bookingActions?.clientBookingSlots({}))
        self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
        self.props.dispatch(productAction.selectedClient({}));
        self.props.dispatch(productAction?.selectCheckoutItem({}));
        self.props.dispatch(productAction?.selectedCheckoutList([]));

        let serviceData = [];
        self.props.dispatch(productAction?.selectedCheckoutList(serviceData));
        self.setState({
          checkoutSelectedItems:[],
        });
      }
      
      // If we're returning from client selection or voucher selection, we need to update accordingly
      const fromVoucherSelection = state?.fromVoucherSelection;
      if (fromClientSelection || fromVoucherSelection) {
        console.log('Returning from selection, preserving item types');
        console.log('fromClientSelection:', fromClientSelection);
        console.log('fromVoucherSelection:', fromVoucherSelection);
        
        // Get the current checkout items
        const currentItems = self.state.checkoutSelectedItems || [];
        
        // Find the item that matches the indexId from the client selection
        const indexId = state?.indexId || (self.props.selectedClient?.indexId ? +self.props.selectedClient.indexId : null);
        const targetItem = indexId ? currentItems.find(item => item.id === indexId) : null;
        
        console.log('componentDidMount - targetItem:', targetItem);
        console.log('componentDidMount - indexId:', indexId);
        
        // Determine the correct type based on the current item's properties
        let correctType = 'service'; // Default to service
        
        if (targetItem) {
          // First check if the item has an explicit type
          if (targetItem.type) {
            correctType = targetItem.type;
          }
          // If no explicit type, determine based on properties
          else if (targetItem.selectedService) {
            correctType = 'service';
          } else if (targetItem._id || targetItem.retailPrice !== undefined) {
            correctType = 'product';
          } else if (targetItem.voucherPrice !== undefined || targetItem.voucherId) {
            correctType = 'voucher';
          }
          
          console.log('componentDidMount - determined correctType:', correctType);
          
          // Update the state with the correct item type
          if (self.props.history && self.props.history.location) {
            const currentState = { ...self.props.history.location.state };
            currentState.itemType = correctType;
            
            self.props.history.replace({
              pathname: self.props.history.location.pathname,
              state: currentState
            });
            
            console.log('componentDidMount - updated state with correctType:', correctType);
          }
        }
        
        self.setSelectedClient();
      }
    }
  
  
    const body = document.getElementsByClassName("body_container")[0];
    body.classList.remove("cm_bg_white");
    body.classList.add("body_bg_lightGray");

   
    let params = {
      defaultRedirectTo: localStorage.getItem("defaultRedirectTo"),
    };
    localStorage.setItem("isShow", "true");
   
    let params1 = {
      searchKey: this.state.searchKey,
      hairdresserId: localStorage.getItem("userId"),
      page: 1,
      listType: 1,
    };
    if(self.props.staffRota?.rota != undefined) {
      let staffData = self.props.staffRota?.rota != undefined ? self.props.staffRota?.rota : [];
      console.log("staffData",staffData);
      const staffOptionList = staffData?.map((staff) => {
        return {value: staff?._id, label: staff?.name};
      });

      const serviceHardresserList = staffData?.map((staff) => {
        return {id: staff?._id, name: staff?.name};
      });


      self.setState({
        staffList: staffOptionList,
        serviceHardresserList: serviceHardresserList,
      });
    }
    self.calculateCheckoutItem();
    this.setSelectedCheckoutData();
    
    // Fetch payment method settings
    self.fetchPaymentMethods();
    if (localStorage.getItem("accessToken")) {
      self.props
        .dispatch(userActions.profile(params))
        .then(function (response) {
          if (response.data.data) {
            self.setState({
              locationId: response?.data?.data?.userInfo?.hairdresser
                ?.stripeLocationId
                ? response?.data?.data?.userInfo?.hairdresser?.stripeLocationId
                : "",
            });
            self.cardReaderList(response.data.data.userInfo);
          }
        });

      self.cardReaderList();
      self.props.dispatch(hairdresserActions.hairdresserStaffRota(params1))
          .then(function (response) {
            let staffData = response?.data?.data?.rota!=undefined?response?.data?.data?.rota:[];
           const staffOptionList =  staffData?.map(staff=>{
              return {value:staff?._id,label:staff?.name}
            })
            self.setState({
              staffList:staffOptionList
            })
          })

    } else {
      this.props.history.push("/");
    }

    let { hairdresser } = this.props;

    if (
      this.props?.hairdresserBooking?.bookings &&
      this.props?.hairdresserBooking?.bookings?.length > 0
    ) {
      let prev = this.props?.hairdresserBooking?.bookings[0]?.servicesBooked;

      let servicesData = [];
      let hairdresserServices = hairdresser?.hairdresserServices;
      for (let i = 0; i < hairdresserServices?.length; i++) {
        let category = hairdresserServices[i].hairdresserService;
        for (let j = 0; j < category.length; j++) {
          servicesData.push(category[j]);
        }
      }

      let temp = [];

      const filterData = servicesData.filter(
        (serviceData) =>
          !prev.some(
            (prevService) => prevService.serviceId === serviceData.serviceId
          )
      );

      for (let i = 0; i < prev.length; i++) {
        temp.push(filterData);
      }

      let staffMember =
        this?.props?.hairdresserBooking?.bookings[0]?.hairdresser.name;

      let path =
        this.props.history.location?.state?.pname === "ListCheckout"
          ? this.props.history.location?.state?.pname
          : "";
      let serviceNumber = this.props.history.location?.state?.serviceNumber;
      if (path === "ListCheckout" && serviceNumber <= prev.length) {
        prev[serviceNumber] = this.props.history.location?.state?.product;
        self.setState({
          selectSlot: this.props.history.location?.state?.startTime,
          totalTime: this.props.history.location?.state?.serviceDuration,
          totalAmount: this.props.history.location?.state?.previousPrice,
          pendingAmount: this.props.history.location?.state?.previousPrice,
        });
      } else if (serviceNumber > prev.length) {
        prev.push(this.props.history.location.state.product);
      }

      this.setState({
        allServices: servicesData,
        fromServices: temp,
        selectedServices: prev,
        hairDresserName: staffMember,
        newStartTime: this?.state?.selectSlot,
      });
    }
  }



  calculateCheckoutItem() {
    let self = this;
    // Use the component's state instead of props to ensure removed items stay removed
    let selectedCheckoutList = this.state?.checkoutSelectedItems?.length>0?this.state.checkoutSelectedItems:[];
    let totalServicePrice = 0;
    let totalRetailPrice = 0;
    let totalVoucherPrice = 0;
    let selectedProduct = [];
    let _selectedServices = [];
    let _selectedVouchers = [];

    console.log('calculateCheckoutItem - selectedCheckoutList:', selectedCheckoutList);

    // First, ensure all items have their types explicitly set and preserved
    selectedCheckoutList = selectedCheckoutList.map(item => {
      // Always preserve the type based on the item's properties
      if (item.type === 'service' || item.selectedService) {
        return {...item, type: "service"};
      } else if (item.type === 'product') {
        return {...item, type: "product"};
      } else if (item.type === 'voucher') {
        return {...item, type: "voucher"};
      }
      // If the item has selectedService but no type, it should be a service
      else if (item.selectedService) {
        return {...item, type: "service"};
      }
      // If we can't determine the type, log a warning
      console.warn('calculateCheckoutItem - unable to determine type for item:', item);
      return item;
    });

    for (const item of selectedCheckoutList) {
      // Log each item to help with debugging
      console.log('calculateCheckoutItem - processing item:', item);
      
      // Process each item based on its type
      if (item.type === "product") {
        selectedProduct.push({...item, type: "product"});
        totalRetailPrice += item?.retailPrice !== undefined ? parseFloat(item?.retailPrice) : 0;
      } else if (item?.type === "service") {
        _selectedServices.push({...item, type: "service"});
        totalServicePrice += item?.selectedService?.servicePrice !== undefined ? parseFloat(item?.selectedService?.servicePrice): 0;
      } else if (item?.type === "voucher") {
        _selectedVouchers.push({...item, type: "voucher"});
        totalVoucherPrice += item?.voucherPrice !== undefined ? parseFloat(item?.voucherPrice) : 0;
      } else if (item?.selectedService) {
        // If an item has selectedService but no type, it should be a service
        console.log('calculateCheckoutItem - fixing item with missing type:', item);
        _selectedServices.push({...item, type: "service"});
        totalServicePrice += item?.selectedService?.servicePrice !== undefined ? parseFloat(item?.selectedService?.servicePrice): 0;
      }
    }

    const checkOutTotalAmount = totalServicePrice + totalRetailPrice + totalVoucherPrice;
    
    // Calculate the amount paid by vouchers
    let voucherPaymentAmount = 0;
    if (this.state.transaction && this.state.transaction.length > 0) {
      voucherPaymentAmount = this.state.transaction
        .filter(transaction => transaction.paymentType === 11) // Filter voucher transactions
        .reduce((total, transaction) => total + parseFloat(transaction.amount || 0), 0);
    }
    
    // Calculate the pending amount after voucher payments
    const pendingAmountAfterVouchers = Math.max(0, checkOutTotalAmount - voucherPaymentAmount);
    
    console.log('Calculate Checkout Item - Total Amount:', checkOutTotalAmount);
    console.log('Calculate Checkout Item - Voucher Payment Amount:', voucherPaymentAmount);
    console.log('Calculate Checkout Item - Pending Amount After Vouchers:', pendingAmountAfterVouchers);

    // Log the categorized items
    console.log('calculateCheckoutItem - _selectedServices:', _selectedServices);
    console.log('calculateCheckoutItem - selectedProduct:', selectedProduct);
    console.log('calculateCheckoutItem - _selectedVouchers:', _selectedVouchers);

    const updatedData = {
      selectedService: _selectedServices.map(service => ({...service, type: "service"})),
      productList: selectedProduct.map(product => ({...product, type: "product"})),
      voucherList: _selectedVouchers.map(voucher => ({...voucher, type: "voucher"})),
      totalAmount: checkOutTotalAmount,
      pendingAmount: pendingAmountAfterVouchers,
      totalPaymentAmount: voucherPaymentAmount,
      paymentAmount: checkOutTotalAmount,
      selectedTotalAmount: checkOutTotalAmount,
    };
    
    console.log('calculateCheckoutItem - updatedData:', updatedData);

    self.setState(updatedData);
    return updatedData;
  }


  serviceHairdresserList = (salonId, selectedHairdresserService) => {
    let self = this;
    let hairdresserListParam = {
      salonId: salonId,
      selectedService: selectedHairdresserService,
    };
    self.props
      .dispatch(hairdresserActions.serviceHairdresserList(hairdresserListParam))
      .then(function (response) {
        if (response.data.errorCode) {
          self.setState({
            error: response.data.error.messages,
          });
        } else {
          const data = response?.data?.responseData || response?.data?.data;
          self.setState({
            serviceHardresserList: data,
          });
        }
      });
  };




  resetBooking() {
    window.location.reload();
  }

  changeClient() {
    this.setState({
      selectedClientId: "",
      selectedClient: {},
      isSaveBooking: 0,
      bookingSlots: [],
      paymentType: "", //start working from here
      searchKey: "",
    });
  }

  handleEvent(e, d) {
    if (e === "eventStartTime") {
      let m = moment(d);
      let minutes = m.hour() * 60 + m.minute();
      this.setState({ eventTime: d, eventStartTime: minutes });
    }
    if (e === "eventEndTime") {
      let m = moment(d);
      let minutes = m.hour() * 60 + m.minute();
      this.setState({ endTime: d, eventEndTime: minutes });
    }
    if (typeof e === "object" && e.target.id === "eventTitle") {
      this.setState({ eventTitle: e.target.value });
    }
    if (typeof e === "object" && e.target.id === "isBookingAllowed") {
      this.setState({ isBookingAllowed: !this.state.isBookingAllowed });
    }
  }

checkoutBooking() {
    this.setState({
      isCheckout: 1,
    });
  }


  onChanged(e) {
    this.setState({ [e.target.name]: parseFloat(e.target.value) });
    if (e.target.name === "registrationCode") {
      this.setState({ [e.target.name]: e.target.value });
    } else if (e.target.name === "label") {
      this.setState({ [e.target.name]: e.target.value });
    } else {
      this.setState({ [e.target.name]: parseFloat(e.target.value) });
    }
    if (e.target.name === "pendingAmount") {
      let totalPaymentAmount =
        parseFloat(this.state.totalPaymentAmount) + parseFloat(e.target.value);
      let pendingAmount =
        parseFloat(this.state.totalAmount) - totalPaymentAmount;
      if (parseFloat(e.target.value) > pendingAmount) {
        this.setState({
          paymentAmountError: "Invalid Amount",
        });
      } else {
        this.setState({
          paymentAmountError: "",
        });
      }
    }
  }

  createBooking=(callback='')=>{
    let self=this;
    let filteredProduct = [];
    let filteredService = [];
    let filteredVoucher = [];
    let transaction = this.state.transaction;
    
    console.log('createBooking - checkoutSelectedItems:', self?.state?.checkoutSelectedItems);
    console.log('createBooking - voucher items in list:', self?.state?.checkoutSelectedItems.filter(item => item.type === 'voucher').length);

    // _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
    //   if(_checkOutSelectedItem?.type==='product'){
    //     filteredProduct.push(_checkOutSelectedItem?._id)
    //   }else{
    //     filteredService.push(_checkOutSelectedItem?.selectedService?.serviceId)
    //   }
    // })

    _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
      console.log('createBooking - processing item:', _checkOutSelectedItem);
      
      // Ensure we check for selectedService to determine if it's a service when type is missing
      if(_checkOutSelectedItem?.type==='product'){
        filteredProduct.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,retailPrice:parseFloat(_checkOutSelectedItem?.retailPrice), type: 'product'})
      } else if(_checkOutSelectedItem?.type==='service'){
        filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
      } else if(_checkOutSelectedItem?.type==='voucher'){
        console.log('createBooking - processing voucher item:', _checkOutSelectedItem);
        // Create a new voucher object with only voucher-specific properties, similar to how services are handled
        filteredVoucher.push({
          // Only include voucher-specific properties
          id: _checkOutSelectedItem?._id,
          voucherName: _checkOutSelectedItem?.voucherName || '',
          voucherPrice: parseFloat(_checkOutSelectedItem?.voucherPrice || 0),
          voucherCode: _checkOutSelectedItem?.voucherCode || '',
          voucherType: _checkOutSelectedItem?.voucherType || '',
          voucherDescription: _checkOutSelectedItem?.voucherDescription || '',
          currency: _checkOutSelectedItem?.currency || '£',
          value: _checkOutSelectedItem?.value || 0,
          type: 'voucher' // Explicitly set type to voucher
        });
      } else if(_checkOutSelectedItem?.selectedService) {
        // If an item has selectedService but no type, it should be a service
        console.log('createBooking - fixing item with missing type:', _checkOutSelectedItem);
        filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
      }
    })
    
    console.log('createBooking - filteredProduct:', filteredProduct);
    console.log('createBooking - filteredService:', filteredService);
    console.log('createBooking - filteredVoucher:', filteredVoucher);
    
    // Log the types of each item for debugging
    console.log('createBooking - Product types:', filteredProduct.map(item => item.type));
    console.log('createBooking - Service types:', filteredService.map(item => item.type));
    console.log('createBooking - Voucher types:', filteredVoucher.map(item => item.type));

    if(filteredProduct?.length>0 || filteredService?.length>0 || filteredVoucher?.length>0) {
      self.setState({
        productList: filteredProduct,
        serviceList: filteredService,
        voucherList: filteredVoucher
      })
      let totalPaymentAmount =
          parseFloat(this.state.totalPaymentAmount) +
          parseFloat(this.state.pendingAmount);
      let paramsCheckOut = {
        hairdresserId: self.state.selectedStaff?.value,
        salonId: self?.props?.match?.params?.salonId,
        servicesBooked: filteredService,
        products: filteredProduct,
        vouchers: filteredVoucher,
        isCheckout: 1,
        bookingStatus: 1,
        totalAmount: totalPaymentAmount,
        userId: this.state.selectedClient._id,
        transaction: JSON.stringify(transaction),
        selectedPaymentType: this.state.isCardReaderConnected ? 5 : this.state.selectedPaymentType
      }
      
      console.log('createBooking - paramsCheckOut:', paramsCheckOut);
      console.log('createBooking - paramsCheckOut.vouchers:', paramsCheckOut.vouchers);

      self.props.dispatch(bookingActions?.createNewCheckoutBooking(paramsCheckOut))
          .then(res => {
            console.log('createBooking - response received:', res.data);
            const newBookingId = res.data?.responseData?.result?._id;
            console.log('createBooking - extracted bookingId:', newBookingId);
            self.setState({
              bookingId: newBookingId
            },()=>{
              console.log('createBooking - bookingId set in state:', self.state.bookingId);
              // Update any pending voucher redemptions with the new booking ID
              if (self.state.pendingVoucherRedemption) {
                const { voucherId, redemptionIndex } = self.state.pendingVoucherRedemption;
                console.log('Updating voucher redemption with booking ID:', { voucherId, redemptionIndex, bookingId: newBookingId });
                
                self.props.dispatch(voucherActions.updateVoucherRedemption(voucherId, redemptionIndex, newBookingId))
                  .then(response => {
                    if (response.data && response.data.statusCode === 1) {
                      console.log('Successfully updated voucher redemption with booking ID');
                      // Clear the pending voucher redemption
                      self.setState({ pendingVoucherRedemption: null });
                    } else {
                      console.error('Error updating voucher redemption with booking ID');
                    }
                  })
                  .catch(error => {
                    console.error('Error updating voucher redemption with booking ID:', error);
                  });
              }
              
              // localStorage.setItem('bookingId',res.data?.responseData?.result?._id);
              if(callback!=''&& callback!=undefined){
                callback();
              }
            })
          })
    }
}


editCheckoutBooking=()=>{
  let self=this;
  let filteredProduct = [];
  let filteredService = [];
  let filteredVoucher = [];
  let transaction = this.state.transaction;
  
  console.log('editCheckoutBooking - checkoutSelectedItems:', self?.state?.checkoutSelectedItems);
  
  _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
    console.log('editCheckoutBooking - processing item:', _checkOutSelectedItem);
    
    // Ensure we check for selectedService to determine if it's a service when type is missing
    if(_checkOutSelectedItem?.type==='product'){
      filteredProduct.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,retailPrice:parseFloat(_checkOutSelectedItem?.retailPrice), type: 'product'})
    } else if(_checkOutSelectedItem?.type==='service'){
      filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
    } else if(_checkOutSelectedItem?.type==='voucher'){
      filteredVoucher.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,voucherPrice:parseFloat(_checkOutSelectedItem?.voucherPrice || 0), type: 'voucher'});
    } else if(_checkOutSelectedItem?.selectedService) {
      // If an item has selectedService but no type, it should be a service
      console.log('editCheckoutBooking - fixing item with missing type:', _checkOutSelectedItem);
      filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
    }
  })

  // _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
  //   if(_checkOutSelectedItem?.type==='product'){
  //     filteredProduct.push(_checkOutSelectedItem?._id)
  //   }else{
  //     filteredService.push(_checkOutSelectedItem?.selectedService?.serviceId)
  //   }
  // })
  
  console.log('editCheckoutBooking - filteredProduct:', filteredProduct);
  console.log('editCheckoutBooking - filteredService:', filteredService);
  console.log('editCheckoutBooking - filteredVoucher:', filteredVoucher);

  if(filteredProduct?.length>0 || filteredService?.length>0 || filteredVoucher?.length>0) {
    self.setState({
      productList: filteredProduct,
      serviceList: filteredService,
      voucherList: filteredVoucher
    })
    let totalPaymentAmount =
        parseFloat(this.state.totalPaymentAmount) +
        parseFloat(this.state.pendingAmount);
    let paramsCheckOut = {
      bookingId:self.state.bookingId,
      hairdresserId: self.state.selectedStaff?.value,
      salonId: self?.props?.match?.params?.salonId,
      servicesBooked: filteredService,
      products: filteredProduct,
      vouchers: filteredVoucher,
      isCheckout: 1,
      totalAmount: totalPaymentAmount,
      userId: this.state.selectedClient._id,
      transaction: JSON.stringify(transaction),
      selectedPaymentType: this.state.isCardReaderConnected ? 5 : this.state.selectedPaymentType
    }
    
    console.log('editCheckoutBooking - paramsCheckOut:', paramsCheckOut);

    self.props.dispatch(bookingActions?.editCheckoutBooking(paramsCheckOut))
        .then(res => {
          const newBookingId = res.data?.responseData?.result?._id;
          self.setState({
            bookingId: newBookingId
          }, () => {
            // Update any pending voucher redemptions with the new booking ID
            if (self.state.pendingVoucherRedemption) {
              const { voucherId, redemptionIndex } = self.state.pendingVoucherRedemption;
              console.log('Updating voucher redemption with booking ID:', { voucherId, redemptionIndex, bookingId: newBookingId });
              
              self.props.dispatch(voucherActions.updateVoucherRedemption(voucherId, redemptionIndex, newBookingId))
                .then(response => {
                  if (response.data && response.data.statusCode === 1) {
                    console.log('Successfully updated voucher redemption with booking ID');
                    // Clear the pending voucher redemption
                    self.setState({ pendingVoucherRedemption: null });
                  } else {
                    console.error('Error updating voucher redemption with booking ID');
                  }
                })
                .catch(error => {
                  console.error('Error updating voucher redemption with booking ID:', error);
                });
            }
          });
        })
  }
}


  checkCompleteSale = () => {
    console.log('InstantCheckout - checkCompleteSale called');
    console.log('InstantCheckout - isCheckoutPayment:', this.state.isCheckoutPayment);
    console.log('InstantCheckout - pendingAmount:', this.state.pendingAmount);
    console.log('InstantCheckout - selectedPaymentType:', this.state.selectedPaymentType);
    console.log('InstantCheckout - checkOutAmountType:', this.state.checkOutAmountType);
    console.log('InstantCheckout - selectedAmount:', this.state.selectedAmount);
    console.log('InstantCheckout - isCardReaderConnected:', this.state.isCardReaderConnected);
    
    if (this.state.isCheckoutPayment === true) {
      console.log('InstantCheckout - returning true (isCheckoutPayment) - DISABLED');
      return true;
    }
    if (this.state.pendingAmount == 0) {
      console.log('InstantCheckout - returning false (pendingAmount is 0) - ENABLED');
      return false;
    }
    if (this.state.selectedPaymentType !== null) {
      // For payment link (type 12), Klarna (type 13), or Clearpay (type 14) with custom amount, amount must be > 0
      if((this.state.selectedPaymentType === 12 || this.state.selectedPaymentType === 13 || this.state.selectedPaymentType === 14) && !this.state.checkOutAmountType){
        const amount = parseFloat(this.state.selectedAmount);
        const paymentTypeName = this.state.selectedPaymentType === 12 ? 'Payment Link' : this.state.selectedPaymentType === 13 ? 'Klarna' : 'Clearpay';
        console.log(`InstantCheckout - ${paymentTypeName} custom amount parsed:`, amount);
        if(isNaN(amount) || amount <= 0){
          console.log(`InstantCheckout - returning true (${paymentTypeName} with invalid/zero custom amount) - DISABLED`);
          return true; // Disable button
        }
      }
      console.log('InstantCheckout - returning false (payment type selected) - ENABLED');
      return false;
    }
    if (
      this.state.checkOutAmountType == 1 &&
      this.state.isCardReaderConnected === true
    ) {
      console.log('InstantCheckout - returning false (card reader connected) - ENABLED');
      return false;
    }
    console.log('InstantCheckout - returning true (no payment method) - DISABLED');
    return true;
  };

  completeSale() {
    let self = this;
    // console.log('check the cardreader',this.state.selectedCardReader)
    // return;
    
    // Check if gift card payment type is selected
    if (this.state.selectedPaymentType === 11) {
      // Automatically trigger the find voucher process
      this.openFindVoucherModal();
      return; // Exit the function early
    }
    
    // Check if Payment Link payment type is selected
    if (this.state.selectedPaymentType === 12) {
      // Trigger payment link creation
      this.createPaymentLink();
      return; // Exit the function early
    }
    
    // Check if Klarna payment type is selected
    if (this.state.selectedPaymentType === 13) {
      // Trigger Klarna payment link creation
      this.createKlarnaPaymentLink();
      return; // Exit the function early
    }

    // Check if Clearpay payment type is selected
    if (this.state.selectedPaymentType === 14) {
      // Trigger Clearpay payment link creation
      this.createClearpayPaymentLink();
      return; // Exit the function early
    }
    
    this.setState({
      paymentAmountError: "",
    });

    let filteredProduct = [];
    let filteredService = [];
    let filteredVoucher = [];
    
    console.log('completeSale - checkoutSelectedItems:', self?.state?.checkoutSelectedItems);
    
    if(self?.state?.checkoutSelectedItems?.length>0){
      // _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
      //   if(_checkOutSelectedItem?.type==='product'){
      //     filteredProduct.push(_checkOutSelectedItem?._id)
      //   }else{
      //     filteredService.push(_checkOutSelectedItem?.selectedService?.serviceId)
      //   }
      //  })

      _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
        console.log('completeSale - processing item:', _checkOutSelectedItem);
        
        // Ensure we check for selectedService to determine if it's a service when type is missing
        if(_checkOutSelectedItem?.type==='product'){
          filteredProduct.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,retailPrice:parseFloat(_checkOutSelectedItem?.retailPrice), type: 'product'})
        } else if(_checkOutSelectedItem?.type==='service'){
          filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
        } else if(_checkOutSelectedItem?.type==='voucher'){
          // Create a new voucher object with only voucher-specific properties, similar to how services are handled
          filteredVoucher.push({
            // Only include voucher-specific properties
            id: _checkOutSelectedItem?._id,
            voucherName: _checkOutSelectedItem?.voucherName || '',
            voucherPrice: parseFloat(_checkOutSelectedItem?.voucherPrice || 0),
            voucherCode: _checkOutSelectedItem?.voucherCode || '',
            voucherType: _checkOutSelectedItem?.voucherType || '',
            voucherDescription: _checkOutSelectedItem?.voucherDescription || '',
            currency: _checkOutSelectedItem?.currency || '£',
            value: _checkOutSelectedItem?.value || 0,
            type: 'voucher' // Explicitly set type to voucher
          });
        } else if(_checkOutSelectedItem?.selectedService) {
          // If an item has selectedService but no type, it should be a service
          console.log('completeSale - fixing item with missing type:', _checkOutSelectedItem);
          filteredService.push({..._checkOutSelectedItem?.selectedService,id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice, type: 'service'});
        }
      })
      
      console.log('completeSale - filteredProduct:', filteredProduct);
      console.log('completeSale - filteredService:', filteredService);
      console.log('completeSale - filteredVoucher:', filteredVoucher);
      
      // Log the types of each item for debugging
      console.log('completeSale - Product types:', filteredProduct.map(item => item.type));
      console.log('completeSale - Service types:', filteredService.map(item => item.type));
      console.log('completeSale - Voucher types:', filteredVoucher.map(item => item.type));

       if(filteredProduct?.length>0 || filteredService?.length>0 || filteredVoucher?.length>0){
        self.setState({
          productList: filteredProduct,
          serviceList: filteredService,
          voucherList: filteredVoucher
        })

          if (this.state.pendingAmount === 0) {
            // Check if there are any gift card transactions
            const hasGiftCardTransactions = this.state.transaction.some(
              transaction => transaction.paymentType === 11
            );
            
            // If there are only gift card transactions and pendingAmount is 0,
            // we need to set isPaymentComplete to 1 to allow checkout to proceed
            if (hasGiftCardTransactions && this.state.isPaymentComplete === 0) {
              // For gift card payments, we need to create a booking with status 4 (complete)
              // instead of calling checkout which would create a booking with status 1
              let transaction = this.state.transaction;
              let totalPaymentAmount = parseFloat(this.state.totalPaymentAmount);
              
              console.log('completeSale - creating booking with status 4 for gift card payment');
              
              let paramsCheckOut = {
                hairdresserId: self.state.selectedStaff?.value,
                salonId: self?.props?.match?.params?.salonId,
                servicesBooked: filteredService,
                products: filteredProduct,
                vouchers: filteredVoucher,
                isCheckout: 1,
                bookingStatus: 4, // Set status to complete
                totalAmount: totalPaymentAmount,
                userId: this.state.selectedClient._id,
                transaction: JSON.stringify(transaction),
                selectedPaymentType: null // Gift card payment
              };
              
              console.log('completeSale - paramsCheckOut for gift card:', paramsCheckOut);
              
              self.props.dispatch(bookingActions?.createNewCheckoutBooking(paramsCheckOut))
                .then(res => {
                  if (res?.data?.statusCode === 1) {
                    self.props.dispatch(productAction?.selectedClient({}));
                    self.props.dispatch(productAction?.selectedCheckoutList([]));
                    self.props.history.push('/invoice/' + res.data?.responseData?.result?._id);
                  }
                })
                .catch((error) => {
                  console.log('complete sales error for gift card', error);
                });
            } else if (this.state.isPaymentComplete === 0) {
              this.setState({
                isPaymentComplete: 1,
              });
            } else {
              this.setState({ isInvoice: 1 }, this.editCheckoutBooking());
            }
          } else {

    // panding amount code
    if (this.state.selectedAmount > 0) {
      let transaction = this.state.transaction;
          transaction.push({
            paymentType: self.state.selectedPaymentType,
            amount: parseFloat(this.state.selectedAmount),
          });
          let totalPaymentAmount =
              parseFloat(this.state.totalPaymentAmount) +
              parseFloat(this.state.selectedAmount);
          let pendingAmount =
              parseFloat(this.state.totalAmount) - totalPaymentAmount;
          let isPaymentComplete = 0;
          if (pendingAmount === 0) {
            isPaymentComplete = 1;
          }
          this.setState({
            totalPaymentAmount,
            transaction: transaction,
            pendingAmount: pendingAmount,
            selectedAmount: "",
            selectedPaymentType: null,
            checkOutAmountType: true,
            isPaymentComplete,
          },function (){
            self.createBooking();
          });

        }else{
          let transaction = this.state.transaction;
            if (this.state.checkOutAmountType == true) {
              transaction.push({
                paymentType: self.state.selectedPaymentType,
                amount: parseFloat(this.state.pendingAmount),
              });
              let totalPaymentAmount =
                parseFloat(this.state.totalPaymentAmount) +
                parseFloat(this.state.pendingAmount);
              let paramsCheckOut = {
                hairdresserId:self.state.selectedStaff?.value,
                salonId:self?.props?.match?.params?.salonId,
                servicesBooked:filteredService,
                products:filteredProduct,
                vouchers:filteredVoucher,
                isCheckout:1,
                totalAmount:totalPaymentAmount,
                userId:this.state.selectedClient._id,
                transaction:JSON.stringify(transaction),
                bookingStatus: 4,
               }
               
              console.log('completeSale - paramsCheckOut:', paramsCheckOut);

               self.props.dispatch(bookingActions?.createNewCheckoutBooking(paramsCheckOut)).then(res=>{
                if(res?.data?.statusCode===1){
                  self.props.dispatch(productAction?.selectedClient({}));
                  self.props.dispatch(productAction?.selectedCheckoutList([]));
                  self.props.history.push('/invoice/'+res.data?.responseData?.result?._id);
                }
                }).catch((error)=>{
                  console.log('complete sales error',error)
               })
            }
        }


            
          }

       }else{
        this.setState({
          paymentAmountError: "Please select service, product, or voucher.",
        });
       }
    }

    if(parseFloat(this.state.selectedAmount)<=0){
      this.setState({
          paymentAmountError:'Please enter some amount'
      })
      }else {
            this.setState({isInvoice: 1})
        }
  }

  completeSaleForCardReader=()=> {


    this.setState({
      paymentAmountError: "",
    });
    let self = this;

      if (this.state.pendingAmount === 0) {
      if (this.state.isPaymentComplete == 0) {
        this.setState({
          isPaymentComplete: 1,
        });
      } else {
        this.editCheckoutBooking()
      }
    } else {
      let transaction = this.state.transaction;
      if (this.state.checkOutAmountType == true) {
        transaction.push({
          paymentType: self.state.selectedPaymentType,
          amount: parseFloat(this.state.pendingAmount),
        });
        let totalPaymentAmount =
            parseFloat(this.state.totalPaymentAmount) +
            parseFloat(this.state.pendingAmount);
        let pendingAmount =
            parseFloat(this.state.totalAmount) - totalPaymentAmount;
        let isPaymentComplete = 0;
        if (pendingAmount === 0) {
          isPaymentComplete = 1;
        }
        this.setState({
          totalPaymentAmount,
          transaction: transaction,
          pendingAmount: pendingAmount,
          selectedPaymentType: null,
          isPaymentComplete,
        });
      } else {
        if (
            parseFloat(this.state.selectedAmount) >
            parseFloat(this.state.totalAmount) -
            parseFloat(this.state.totalPaymentAmount)
        ) {
          this.setState({
            paymentAmountError: "Please enter valid amount",
          });
        } else if (this.state.selectedAmount == 0) {
          this.setState({
            paymentAmountError: "Please enter valid amount",
          });
        } else if (this.state.selectedAmount > 0) {

          transaction.push({
            paymentType: self.state.selectedPaymentType,
            amount: parseFloat(this.state.selectedAmount),
          });
          let totalPaymentAmount =
              parseFloat(this.state.totalPaymentAmount) +
              parseFloat(this.state.selectedAmount);
          let pendingAmount =
              parseFloat(this.state.totalAmount) - totalPaymentAmount;
          let isPaymentComplete = 0;
          if (pendingAmount === 0) {
            isPaymentComplete = 1;
          }
          this.setState({
            totalPaymentAmount,
            transaction: transaction,
            pendingAmount: pendingAmount,
            selectedAmount: "",
            selectedPaymentType: null,
            checkOutAmountType: true,
            isPaymentComplete,
          },function (){
            self.createBooking();
          });

        }
      }
    }
  }


  setPaymentType = (paymentType) => {
    console.log('check payment type',paymentType)
    this.setState({
      payoutError: "",
      cardReaderConnectError: "",
      selectedCardReader: {},
      selectedPaymentType: paymentType,
      isCardReaderConnected: false,
    });
  };
  
  // Voucher redemption methods
  openFindVoucherModal() {
    this.setState({ showFindVoucherModal: true });
  }
  
  closeFindVoucherModal() {
    this.setState({ showFindVoucherModal: false });
  }
  
  findVoucher(code) {
    // Close the find voucher modal
    this.setState({ showFindVoucherModal: false, isLoadingVoucher: true });
    
    // Call API to find voucher by code
    this.props.dispatch(voucherActions.getVoucherByCode(code))
      .then(response => {
        this.setState({ isLoadingVoucher: false });
        
        if (response.data && response.data.statusCode === 1 && response.data.responseData) {
          const responseData = response.data.responseData;
          let formattedVoucher;
          
          // Handle the new format with voucher instance data
          if (responseData.data && responseData.data.id) {
            const voucher = responseData.data;
            
            // Check if voucher has remaining value
            if (voucher.remainingValue <= 0) {
              toast.error('This voucher has no remaining balance');
              return;
            }
            
            // Format the voucher data for the RedeemVoucherModal component
            formattedVoucher = {
              _id: voucher.id,
              code: voucher.code,
              value: voucher.faceValue,
              remainingValue: voucher.remainingValue,
              currency: voucher.currency || 'GBP',
              expiresAt: voucher.expiresAt ? moment(voucher.expiresAt).format('DD.MM.YY') : 'N/A',
              type: voucher.type,
              saleId: voucher.id // Use the voucher instance ID as the sale ID
            };
          }
          // Check if we have the data in the old format (with voucher and voucherSale)
          else if (responseData.data && responseData.data.voucher && responseData.data.voucherSale) {
            const voucherData = responseData.data.voucher.data;
            const voucherSale = responseData.data.voucherSale;
            
            // Check if voucher has remaining value
            if (voucherSale.remainingValue <= 0) {
              toast.error('This voucher has no remaining balance');
              return;
            }
            
            // Format the voucher data
            formattedVoucher = {
              _id: voucherData.id,
              code: voucherData.code,
              value: voucherData.value,
              remainingValue: voucherSale.remainingValue,
              currency: voucherData.currency || 'GBP',
              expiresAt: voucherSale.expiresAt ? moment(voucherSale.expiresAt).format('DD.MM.YY') : 'N/A',
              type: voucherData.type,
              saleId: voucherSale._id,
              redemptionCode: voucherSale.redemptionCode
            };
          } else {
            // Handle the old format for backward compatibility
            const voucher = responseData;
            
            // Check if voucher has remaining value
            if (voucher.remainingValue <= 0) {
              toast.error('This voucher has no remaining balance');
              return;
            }
            
            // Format the voucher data
            formattedVoucher = {
              _id: voucher._id,
              code: voucher.code,
              value: voucher.value,
              remainingValue: voucher.remainingValue,
              currency: voucher.currency || 'GBP',
              expiresAt: voucher.expiresAt ? moment(voucher.expiresAt).format('DD.MM.YY') : 'N/A',
              type: voucher.type,
              saleId: voucher.saleId || voucher._id // Use the unique sale ID if available
            };
          }
          
          // Show the redeem voucher modal
          this.setState({
            foundVoucher: formattedVoucher,
            showRedeemVoucherModal: true
          });
        } else {
          // Show error message
          toast.error('Voucher not found or invalid');
        }
      })
      .catch(error => {
        this.setState({ isLoadingVoucher: false });
        toast.error('Error finding voucher');
        console.error('Error finding voucher:', error);
      });
  }
  
  closeRedeemVoucherModal() {
    this.setState({ showRedeemVoucherModal: false });
  }
  
  redeemVoucher(amount) {
    const { foundVoucher } = this.state;
    
    // Close the redeem voucher modal
    this.setState({ showRedeemVoucherModal: false });
    
    // Validate amount
    const redemptionAmount = parseFloat(amount);
    if (isNaN(redemptionAmount) || redemptionAmount <= 0) {
      toast.error('Please enter a valid amount greater than 0');
      return;
    }
    
    if (redemptionAmount > foundVoucher.remainingValue) {
      toast.error(`Cannot redeem more than the remaining balance of ${foundVoucher.currency}${foundVoucher.remainingValue}`);
      return;
    }
    
    // Apply the voucher to checkout
    this.applyVoucherToCheckout(foundVoucher, redemptionAmount);
  }
  
  /**
   * Apply voucher to checkout
   * @param {Object} voucher - Voucher object
   * @param {Number} amount - Amount to redeem
   */
  applyVoucherToCheckout(voucher, amount) {
    // Add the voucher payment to the transaction
    let transaction = this.state.transaction;
    transaction.push({
      paymentType: 11, // Gift Card payment type
      amount: amount,
      voucherId: voucher._id,
      voucherCode: voucher.code
    });
    
    // Update the payment amounts
    let totalPaymentAmount = parseFloat(this.state.totalPaymentAmount) + amount;
    let pendingAmount = parseFloat(this.state.totalAmount) - totalPaymentAmount;
    
    // Don't automatically mark payment as complete even if amount is sufficient
    // This allows the user to review and potentially remove the voucher
    
    // Update the state
    this.setState({
      totalPaymentAmount,
      transaction,
      pendingAmount: Math.max(0, pendingAmount),
      selectedAmount: "",
      selectedPaymentType: null,
      isPaymentComplete: 0, // Always keep payment as incomplete until user confirms
      giftCardApplied: {
        code: voucher.code,
        amount: amount
      }
    }, () => {
      // After updating the state, recalculate the checkout items to ensure totals are correct
      this.calculateCheckoutItem();
    });
    
    // Redeem the voucher directly using the API
    // This will create a pending redemption that will be updated with the booking ID after checkout
    this.props.dispatch(voucherActions.redeemVoucher({
      voucherCode: voucher.code,
      amount: amount
    }))
      .then(response => {
        console.log('Voucher redemption response:', JSON.stringify(response.data, null, 2));
        
        if (response.data && response.data.statusCode === 1) {
          // The correct path to redemptions based on the actual response format
          let redemptions = null;
          
          if (response.data.responseData &&
              response.data.responseData.data &&
              response.data.responseData.data.voucher &&
              response.data.responseData.data.voucher.data &&
              response.data.responseData.data.voucher.data.redemptions) {
            redemptions = response.data.responseData.data.voucher.data.redemptions;
          }
          
          // Store the voucher and redemption index for later association with the booking
          this.setState({
            pendingVoucherRedemption: {
              voucherId: voucher._id,
              redemptionIndex: redemptions ? redemptions.length - 1 : 0
            }
          });
          
          toast.success(`Successfully redeemed ${voucher.currency}${amount} from voucher`);
          
          // Don't automatically create/update booking even if payment is complete
          // Let the user review the transaction and click Confirm manually
        } else {
          // The API call was successful but we're showing an error due to response format mismatch
          // Let's show a success message anyway since the backend operation succeeded
          toast.success(`Successfully redeemed ${voucher.currency}${amount} from voucher`);
          console.warn('Unexpected response format:', response.data);
        }
      })
      .catch(error => {
        toast.error('Error redeeming voucher');
        console.error('Error redeeming voucher:', error);
        // No fallback to a manual balance edit: a refused redemption must stay
        // refused (balance edits are a `refunds` action, access audit 2026-10-02).
      });
  }
  
  openFindVoucherModal = () => {
    this.setState({ showFindVoucherModal: true });
  };
  
  closeFindVoucherModal = () => {
    this.setState({ showFindVoucherModal: false });
  };
  
  // This is a duplicate method that can be removed since we're using arrow functions
  // The method at line 1160 will be used instead
  
  closeRedeemVoucherModal = () => {
    this.setState({ showRedeemVoucherModal: false });
  };
  
  // Payment Link methods
  createPaymentLink() {
    const self = this;
    
    // Prepare the booking data
    let filteredProduct = [];
    let filteredService = [];
    let filteredVoucher = [];
    
    if (self?.state?.checkoutSelectedItems?.length > 0) {
      _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem, i) => {
        if (_checkOutSelectedItem?.type === 'product') {
          filteredProduct.push({ ..._checkOutSelectedItem, id: _checkOutSelectedItem?._id, retailPrice: parseFloat(_checkOutSelectedItem?.retailPrice), type: 'product' })
        } else if (_checkOutSelectedItem?.type === 'service') {
          filteredService.push({ ..._checkOutSelectedItem?.selectedService, id: _checkOutSelectedItem?.selectedService?.serviceId, price: _checkOutSelectedItem?.selectedService?.servicePrice, type: 'service' });
        } else if (_checkOutSelectedItem?.type === 'voucher') {
          filteredVoucher.push({
            id: _checkOutSelectedItem?._id,
            voucherName: _checkOutSelectedItem?.voucherName || '',
            voucherPrice: parseFloat(_checkOutSelectedItem?.voucherPrice || 0),
            voucherCode: _checkOutSelectedItem?.voucherCode || '',
            voucherType: _checkOutSelectedItem?.voucherType || '',
            voucherDescription: _checkOutSelectedItem?.voucherDescription || '',
            currency: _checkOutSelectedItem?.currency || '£',
            value: _checkOutSelectedItem?.value || 0,
            type: 'voucher'
          });
        } else if (_checkOutSelectedItem?.selectedService) {
          filteredService.push({ ..._checkOutSelectedItem?.selectedService, id: _checkOutSelectedItem?.selectedService?.serviceId, price: _checkOutSelectedItem?.selectedService?.servicePrice, type: 'service' });
        }
      });
    }
    
    // Create booking first
    let paramsCheckOut = {
      hairdresserId: self.state.selectedStaff?.value,
      salonId: self?.props?.match?.params?.salonId,
      servicesBooked: filteredService,
      products: filteredProduct,
      vouchers: filteredVoucher,
      isCheckout: 1,
      bookingStatus: 1, // Pending status
      totalAmount: self.state.selectedTotalAmount,
      userId: this.state.selectedClient._id,
      transaction: JSON.stringify([]),
      selectedPaymentType: 12 // Payment Link
    };
    
    self.props.dispatch(bookingActions?.createNewCheckoutBooking(paramsCheckOut))
      .then(res => {
        if (res?.data?.statusCode === 1) {
          const bookingId = res.data?.responseData?.result?._id;
          
          // Store bookingId in state for later use
          self.setState({ bookingId: bookingId });
          
          // Now create the payment link using Redux action (same as BookingCheckout)
          return self.props.dispatch(paymentActions.createPaymentLink({ bookingId: bookingId }));
        } else {
          throw new Error('Failed to create booking');
        }
      })
      .then(response => {
        console.log('Payment link response:', response);
        if (response.data && response.data.statusCode === 1) {
          // Show the modal with payment link data (same pattern as BookingCheckout)
          self.setState({
            showPaymentLinkModal: true,
            paymentLinkData: response.data.responseData,
            selectedPaymentType: null
          });
        } else {
          toast.error(response.data?.responseData?.message || 'Failed to create payment link');
        }
      })
      .catch((error) => {
        console.error('Error creating payment link:', error);
        toast.error('Failed to create payment link');
      });
  }

  createKlarnaPaymentLink() {
    this.createCheckoutPaymentLink(13, 'Klarna', paymentActions.createKlarnaPaymentLink);
  }

  // Clearpay goes through the same v2 checkout booking as Klarna. It used to
  // create its booking on the legacy v1 backend, with no client id in the URL
  // and a v1 response it then read as v2, so it never got as far as a link.
  createClearpayPaymentLink() {
    this.createCheckoutPaymentLink(14, 'Clearpay', paymentActions.createClearpayPaymentLink);
  }

  // Payment-link methods (Klarna 13, Clearpay 14): create the checkout
  // booking on v2, then ask v2 for the provider link and show it.
  createCheckoutPaymentLink(paymentType, label, createLinkAction) {
    const self = this;
    
    // Prepare the booking data
    let filteredProduct = [];
    let filteredService = [];
    let filteredVoucher = [];
    
    if (self?.state?.checkoutSelectedItems?.length > 0) {
      _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem, i) => {
        if (_checkOutSelectedItem?.type === 'product') {
          filteredProduct.push({ ..._checkOutSelectedItem, id: _checkOutSelectedItem?._id, retailPrice: parseFloat(_checkOutSelectedItem?.retailPrice), type: 'product' })
        } else if (_checkOutSelectedItem?.type === 'service') {
          filteredService.push({ ..._checkOutSelectedItem?.selectedService, id: _checkOutSelectedItem?.selectedService?.serviceId, price: _checkOutSelectedItem?.selectedService?.servicePrice, type: 'service' });
        } else if (_checkOutSelectedItem?.type === 'voucher') {
          filteredVoucher.push({
            id: _checkOutSelectedItem?._id,
            voucherName: _checkOutSelectedItem?.voucherName || '',
            voucherPrice: parseFloat(_checkOutSelectedItem?.voucherPrice || 0),
            voucherCode: _checkOutSelectedItem?.voucherCode || '',
            voucherType: _checkOutSelectedItem?.voucherType || '',
            voucherDescription: _checkOutSelectedItem?.voucherDescription || '',
            currency: _checkOutSelectedItem?.currency || '£',
            value: _checkOutSelectedItem?.value || 0,
            type: 'voucher'
          });
        } else if (_checkOutSelectedItem?.selectedService) {
          filteredService.push({ ..._checkOutSelectedItem?.selectedService, id: _checkOutSelectedItem?.selectedService?.serviceId, price: _checkOutSelectedItem?.selectedService?.servicePrice, type: 'service' });
        }
      });
    }
    
    // Create booking first
    let paramsCheckOut = {
      hairdresserId: self.state.selectedStaff?.value,
      salonId: self?.props?.match?.params?.salonId,
      servicesBooked: filteredService,
      products: filteredProduct,
      vouchers: filteredVoucher,
      isCheckout: 1,
      bookingStatus: 1, // Pending status
      totalAmount: self.state.selectedTotalAmount,
      userId: this.state.selectedClient._id,
      transaction: JSON.stringify([]),
      selectedPaymentType: paymentType
    };
    
    self.props.dispatch(bookingActions?.createNewCheckoutBooking(paramsCheckOut))
      .then(res => {
        if (res?.data?.statusCode === 1) {
          const bookingId = res.data?.responseData?.result?._id;
          
          // Store bookingId in state for later use
          self.setState({ bookingId: bookingId });
          
          // Now create the provider payment link
          return self.props.dispatch(createLinkAction({ bookingId: bookingId }));
        } else {
          throw new Error('Failed to create booking');
        }
      })
      .then(response => {
        console.log(label + ' payment link response:', response);
        if (response.data && response.data.statusCode === 1) {
          // Show the modal with payment link data
          self.setState({
            showPaymentLinkModal: true,
            paymentLinkData: response.data.responseData,
            selectedPaymentType: null
          });
        } else {
          toast.error(response.data?.responseData?.message || 'Failed to create ' + label + ' payment link');
        }
      })
      .catch((error) => {
        console.error('Error creating ' + label + ' payment link:', error);
        toast.error('Failed to create ' + label + ' payment link');
      });
  }

  
  handlePaymentComplete() {
    // Navigate to invoice screen after payment is confirmed (same as BookingCheckout)
    this.props.history.push(`/invoice/${this.state.bookingId}`);
  }
  
  checkPaymentStatus() {
    // Use new payment link status API (same as BookingCheckout)
    return paymentService.checkPaymentLinkStatus({
      bookingId: this.state.bookingId
    })
      .then((response) => {
        if (response.data && response.data.statusCode === 1) {
          return response.data.responseData;
        }
        return null;
      })
      .catch((error) => {
        console.error("Error checking payment status:", error);
        return null;
      });
  }
  
  // This is a duplicate method that can be removed since we're using arrow functions
  // The method at line 1204 will be used instead

  selectBookingAmount = (type) => {
    let self = this;
    if (type == 1) {
      self.setState({
        checkOutAmountType: true,
      });
    } else {
      self.setState({
        checkOutAmountType: false,
      });
    }
  };
  removeTransaction = (transaction) => {
    // Log the transaction for debugging
    console.log('Removing transaction:', transaction);
    
    let transactionList = this.state.transaction;
    let newList = _.pull(transactionList, transaction);
    let totalPaymentAmount =
      parseFloat(this.state.totalPaymentAmount) -
      parseFloat(transaction.amount);
    let pendingAmount = parseFloat(this.state.totalAmount) - totalPaymentAmount;
    
    // Check if this is a gift card transaction
    if (transaction.paymentType === 11) {
      console.log('Removing gift card transaction:', transaction);
      
      // Check if voucherId and voucherCode exist
      if (!transaction.voucherId) {
        console.error('Gift card transaction missing voucherId:', transaction);
        toast.error('Error: Gift card transaction missing voucherId');
      } else if (!transaction.voucherCode) {
        console.error('Gift card transaction missing voucherCode:', transaction);
        toast.error('Error: Gift card transaction missing voucherCode');
      } else if (!canMoney('refunds')) {
        // Putting value back on a card is a manual balance edit — `refunds`
        // on the server (access audit 2026-10-02).
        toast.error("You don't have permission to put value back on a gift card. Ask someone who can refund sales.");
      } else {
        console.log('Getting voucher by code:', transaction.voucherCode);
        
        // Get the current voucher from the API to get its current balance
        this.props.dispatch(voucherActions.getVoucherByCode(transaction.voucherCode))
          .then(response => {
            console.log('Get voucher response:', response);
            
            if (response.data && response.data.statusCode === 1 && response.data.responseData && response.data.responseData.data) {
              const voucher = response.data.responseData.data;
              // Calculate the new balance by adding back the amount that was redeemed
              const newBalance = parseFloat(voucher.remainingValue) + parseFloat(transaction.amount);
              
              console.log('Updating voucher balance:', {
                voucherId: transaction.voucherId,
                currentBalance: voucher.remainingValue,
                amountToAdd: transaction.amount,
                newBalance: newBalance
              });
              
              // Update the voucher balance
              this.props.dispatch(voucherActions.updateVoucherBalance(transaction.voucherId, newBalance))
                .then(updateResponse => {
                  console.log('Update voucher balance response:', updateResponse);
                  
                  if (updateResponse.data && updateResponse.data.statusCode === 1) {
                    toast.success(`Successfully restored ${transaction.amount} to gift card`);
                  } else {
                    toast.error('Error restoring gift card balance');
                    console.error('Error response:', updateResponse);
                  }
                })
                .catch(error => {
                  toast.error('Error restoring gift card balance');
                  console.error('Error restoring gift card balance:', error);
                });
            } else {
              toast.error('Error finding gift card data in response');
              console.error('Invalid response format:', response);
            }
          })
          .catch(error => {
            toast.error('Error finding gift card');
            console.error('Error finding gift card:', error);
          });
      }
    }
    
    this.setState({
      totalPaymentAmount,
      pendingAmount,
      transaction: newList,
    }, () => {
      // After updating the state, recalculate the checkout items to ensure totals are correct
      this.calculateCheckoutItem();
    });
  };

  cardReaderList = (hairdresserInfo) => {
    let self = this;
    self.props
      .dispatch(paymentActions.cardReaderList({}))
      .then(function (response) {
        console.log("cardReaderList", response);
        if (response.data.statusCode === 1) {
          self.setState(
            {
              cardReaderList: self.props.cardReaderList,
            },
            function () {
              if (hairdresserInfo?.hairdresser?.isSalonOwner === 1) {
                let count = 0;
                const names = self.state.cardReaderList.map((obj) => {
                  count++;
                });
                self.setState({
                  label: hairdresserInfo?.hairdresser?.salon.salonName
                    ? hairdresserInfo?.hairdresser?.salon?.salonName +
                      ` Card Reader (${count + 1})`
                    : "",
                });
              }
            }
          );
        } else {
        }
      });
  };

  setPaymentCardReader = (cardReader) => {
    let self = this;
    console.log('check the card reader data',cardReader);
    this.setState(
      {
        payoutError: "",
        cardReaderConnectError: "",
        selectedPaymentType: null,
        selectedCardReader: cardReader,
      },
      function () {
        self.discoverReaders();
      }
    );
  };

  checkout = () => {
    let self = this;
    let _bookingId = localStorage.getItem('bookingId')!=undefined&&localStorage.getItem('bookingId')!=null?localStorage.getItem('bookingId'):self.state.bookingId;

    console.log('check booking id',_bookingId)

    if(_bookingId==''|| _bookingId==undefined){
      self.createBooking(self.updatedCheckOut.bind(this));
    }else{
      self.updatedCheckOut();
    }
  };

  updatedCheckOut = () =>{
    let self = this;
    if (this.state.isPaymentComplete === 1) {
      // Check if there are any voucher transactions in the transaction list
      const voucherTransactions = self.state.transaction.filter(
        (transaction) => transaction.paymentType === 11 && transaction.voucherId
      );
      
      // If there are voucher transactions, ensure they are properly finalized
      if (voucherTransactions.length > 0) {
        console.log('Finalizing voucher transactions in checkout:', voucherTransactions);
        
        // Process each voucher transaction
        const voucherPromises = voucherTransactions.map(transaction => {
          // Get the current voucher from the API to get its current balance
          return self.props.dispatch(voucherActions.getVoucherByCode(transaction.voucherCode))
            .then(voucherResponse => {
              if (voucherResponse.data && voucherResponse.data.statusCode === 1 && voucherResponse.data.responseData.data) {
                const voucher = voucherResponse.data.responseData.data;
                
                // The voucher balance was already updated when the voucher was applied,
                // but we need to ensure it's correctly recorded in the booking
                console.log('Voucher transaction finalized for code:', transaction.voucherCode);
                return Promise.resolve();
              } else {
                console.error('Error getting voucher for finalization:', transaction.voucherCode);
                return Promise.reject('Error getting voucher');
              }
            })
            .catch(error => {
              console.error('Error finalizing voucher transaction:', error);
              return Promise.reject(error);
            });
        });
        
        // Wait for all voucher transactions to be finalized
        Promise.all(voucherPromises)
          .then(() => {
            // Update booking status to complete (4) before redirecting
            const updateParams = {
              bookingId: self.state.bookingId,
              bookingStatus: 4 // Set status to complete
            };
            
            console.log('Updating booking status to complete for gift card payment:', updateParams);
            
            // Update the booking status
            self.props.dispatch(bookingActions.completeBookingStatus(updateParams))
              .then(() => {
                // Clear the state and redirect to invoice
                let client = {};
                self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
                self.props.dispatch(productAction.selectedClient(client));
                self.props.dispatch(hairdresserActions.selectedService({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
                self.props.dispatch(productAction?.selectedCheckoutList([]));
                // localStorage.removeItem('bookingId')
                self.props.history.push('/invoice/' + self.state.bookingId);
              })
              .catch(error => {
                console.error('Error updating booking status:', error);
                // Continue with checkout even if there was an error updating status
                let client = {};
                self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
                self.props.dispatch(productAction.selectedClient(client));
                self.props.dispatch(hairdresserActions.selectedService({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
                self.props.dispatch(productAction?.selectedCheckoutList([]));
                self.props.history.push('/invoice/' + self.state.bookingId);
              });
          })
          .catch(error => {
            console.error('Error finalizing voucher transactions:', error);
            // Update booking status to complete (4) before redirecting, even if voucher finalization failed
            const updateParams = {
              bookingId: self.state.bookingId,
              bookingStatus: 4 // Set status to complete
            };
            
            console.log('Updating booking status to complete for gift card payment (after error):', updateParams);
            
            // Update the booking status
            self.props.dispatch(bookingActions.completeBookingStatus(updateParams))
              .then(() => {
                // Continue with checkout even if there was an error with vouchers
                let client = {};
                self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
                self.props.dispatch(productAction.selectedClient(client));
                self.props.dispatch(hairdresserActions.selectedService({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
                self.props.dispatch(productAction?.selectedCheckoutList([]));
                self.props.history.push('/invoice/' + self.state.bookingId);
              })
              .catch(statusError => {
                console.error('Error updating booking status:', statusError);
                // Continue with checkout even if there were errors
                let client = {};
                self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
                self.props.dispatch(productAction.selectedClient(client));
                self.props.dispatch(hairdresserActions.selectedService({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
                self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
                self.props.dispatch(productAction?.selectedCheckoutList([]));
                self.props.history.push('/invoice/' + self.state.bookingId);
              });
          });
      } else {
        // No voucher transactions with voucherId, but we still need to check for gift card transactions
        // This is a fallback in case there are gift card transactions without voucherId
        const hasGiftCardTransactions = self.state.transaction.some(
          transaction => transaction.paymentType === 11
        );
        
        if (hasGiftCardTransactions) {
          // If there are gift card transactions, update the booking status
          const updateParams = {
            bookingId: self.state.bookingId,
            bookingStatus: 4 // Set status to complete
          };
          
          console.log('Updating booking status to complete for gift card payment (no voucherId):', updateParams);
          
          // Update the booking status
          self.props.dispatch(bookingActions.completeBookingStatus(updateParams))
            .then(() => {
              // Clear the state and redirect to invoice
              let client = {};
              self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
              self.props.dispatch(productAction.selectedClient(client));
              self.props.dispatch(hairdresserActions.selectedService({}));
              self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
              self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
              self.props.dispatch(productAction?.selectedCheckoutList([]));
              self.props.history.push('/invoice/' + self.state.bookingId);
            })
            .catch(error => {
              console.error('Error updating booking status:', error);
              // Continue with checkout even if there was an error
              let client = {};
              self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
              self.props.dispatch(productAction.selectedClient(client));
              self.props.dispatch(hairdresserActions.selectedService({}));
              self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
              self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
              self.props.dispatch(productAction?.selectedCheckoutList([]));
              self.props.history.push('/invoice/' + self.state.bookingId);
            });
        } else {
          // No gift card transactions, just clear the state and redirect to invoice
          let client = {};
          self.props.dispatch(bookingActions?.hairdresserNewBookingClient(client));
          self.props.dispatch(productAction.selectedClient(client));
          self.props.dispatch(hairdresserActions.selectedService({}));
          self.props.dispatch(bookingActions?.hairdresserNewBookingStaff({}));
          self.props.dispatch(bookingActions?.hairdresserNewBookingData([]));
          self.props.dispatch(productAction?.selectedCheckoutList([]));
          self.props.history.push('/invoice/' + self.state.bookingId);
        }
      }
    } else {
      self.setState({
        isCheckoutPayment: true,
      });

      let filteredProduct = [];
      let filteredService = [];
      
      // IMPORTANT: Do NOT include voucher SALES in voucherIds for paymentIntents
      // voucherIds should ONLY contain vouchers being REDEEMED (used as payment)
      // Voucher SALES are already in the booking's vouchers array from createBooking
      // Only extract voucher REDEMPTIONS from the transaction array
      let voucherRedemptions = [];
      if (self.state.transaction && self.state.transaction.length > 0) {
        voucherRedemptions = self.state.transaction
          .filter(t => t.paymentType === 11 && t.voucherId && t.voucherCode)
          .map(t => ({
            id: t.voucherId,
            value: parseFloat(t.amount || 0),
            code: t.voucherCode
          }));
      }
    
        _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
        if(_checkOutSelectedItem?.type==='product'){
          filteredProduct.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,retailPrice:parseFloat(_checkOutSelectedItem?.retailPrice)})
        } else if(_checkOutSelectedItem?.type==='voucher'){
          // Voucher SALES are already in the booking from createBooking
          // Do NOT send them to paymentIntents as voucherIds
          console.log('Voucher SALE detected in cart (will NOT be sent as voucherId to paymentIntents):', _checkOutSelectedItem);
        } else{
          filteredService.push({id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice});
        }
      })

      // let servicesToBook = _.map(self.state.selectedService, function (o) {
      //   return {id:o?.service?.serviceId!=undefined?o?.service?.serviceId:o?.serviceId, price:parseFloat(o?.service?.servicePrice!=undefined?o?.servicePrice:o?.service?.servicePrice)};
      // });

      // let productIds = _.map(this.state.productList, function (o) {
      //   return {...o,id:o._id,retailPrice:parseFloat(o?.retailPrice)};
      // });

      // console.log('checkCheckout Data',filteredProduct,filteredService);
      // return ;

      // let servicesToBook = _.map(self.state.selectedService, function (o) {
      //   return o?.selectedService?.serviceId;
      // });

      // Sync current items to backend before creating payment intent
      // This ensures added services/products are reflected in the charge amount
      let filteredVoucherForSync = [];
      _.forEach(self?.state?.checkoutSelectedItems, (_item) => {
        if (_item?.type === 'voucher') {
          filteredVoucherForSync.push({
            _id: _item?._id,
            voucherPrice: parseFloat(_item?.voucherPrice || 0),
            voucherCode: _item?.voucherCode || '',
          });
        }
      });

      const syncParams = {
        bookingId: self.state.bookingId,
        hairdresserId: self.state.selectedStaff?.value,
        salonId: self?.props?.match?.params?.salonId,
        servicesBooked: filteredService,
        products: filteredProduct,
        vouchers: filteredVoucherForSync,
        userId: self.state.selectedClient?._id,
        transaction: JSON.stringify(self.state.transaction),
        totalAmount: parseFloat(self.state.totalAmount || 0).toFixed(2),
        isCheckout: 0,
        selectedPaymentType: self.state.isCardReaderConnected ? 5 : self.state.selectedPaymentType,
      };

      bookingService.editCheckoutBooking(syncParams).then(function() {
      // this function running card payment
      console.log('=== CALLING paymentIntents ===');
      console.log('bookingId from state:', self.state.bookingId);
      console.log('servicesToBook:', filteredService);
      console.log('productIds:', filteredProduct);
      console.log('voucherRedemptions (NOT sales):', voucherRedemptions);
      console.log('selectedPaymentType:', self.state.isCardReaderConnected ? 5 : self.state.selectedPaymentType);

      self.props
          .dispatch(
              paymentActions.paymentIntents({
                bookingId: self.state.bookingId,  // FIX: Changed from this.state to self.state
                servicesToBook:filteredService,
                productIds:filteredProduct,
                voucherIds: voucherRedemptions, // ONLY send voucher REDEMPTIONS, NOT sales
                selectedPaymentType: self.state.isCardReaderConnected ? 5 : self.state.selectedPaymentType  // FIX: Changed from this.state to self.state
              })
          )
          .then(function (response) {
            let transaction = self.state.transaction;
            if(response.data.statusCode===0){
              if( response?.data?.error?.errorCode===10 || response?.data?.error?.errorCode===5 ){
                if(response.data.error.errors.errorCode){
                  self.setState({
                    isCheckoutPayment: false,
                    isCardReaderConnected:false,
                  },()=>{
                    toast.error(response?.data?.error?.errors?.responseMessage);
                  })

                }else{
                  self.setState({
                    isCheckoutPayment: false,
                    isCardReaderConnected:false,
                  },()=>{
                    toast.error(response.data.error.responseMessage);
                  })

                }

                // setTimeout(()=>{
                //   window.location.reload();
                // },4000)
              }
            }
            if (response.data.statusCode === 1) {
              self.setState({
                paymentIntents: response.data.responseData.result,
              });
              let clientSecret = response.data.responseData.result.client_secret;

              terminal.collectPaymentMethod(clientSecret).then(function (result) {
                console.log("collectPaymentMethod_checkout", result);
                if (result.error) {
                  // Placeholder for handling result.error
                  self.setState({
                    isCheckoutPayment: false,
                    payoutError: result.error.message,
                  });
                } else {
                  if (
                      result?.paymentIntent?.amount_details?.tip?.amount !=
                      undefined
                  ) {
                    let tip_amount =
                        result?.paymentIntent?.amount_details?.tip?.amount / 100;
                    self.setState({
                      tipAmount: tip_amount,
                    });
                  } else {
                    console.log(
                        "result_paymentIntent_",
                        self.state.bookingId,
                        result.paymentIntent
                    );
                  }
                  let capturedAmount =
                      response?.data?.responseData?.result?.amount / 100;
                  const filterPaymentType = transaction.filter(
                      (_transaction) => _transaction?.paymentType !== 5
                  );
                  filterPaymentType.push({
                    paymentType: 5,
                    amount: parseFloat(capturedAmount),
                  });
                  self.setState({
                    transaction: filterPaymentType,
                  });
                  self.processPayment(result.paymentIntent);
                  // Placeholder for processing result.paymentIntent
                }
              });
            } else {

            }
          });
    }); // end editCheckoutBooking.then
    }
  }

  discoverReaders = async () => {
    let self = this;
    this.setState({
      activeCLass: true,
      isSearchReader: true,
      isShowConnectionLoader: true,
    });
    const config = {
      simulated: siteSetting.simulated,
      location: this.state.locationId,
    };
    let StripeTerminal = await loadStripeTerminal();
    terminal = StripeTerminal.create({
      onFetchConnectionToken: fetchConnectionToken,
      onUnexpectedReaderDisconnect: unexpectedDisconnect,
    });
    console.log("terminal", terminal);
    terminal.discoverReaders(config).then(function (discoverResult) {
      console.log("discoverReaders !!!: ", discoverResult);
      if (discoverResult.error) {
        console.log("Failed to discover ###: ", discoverResult.error);
        self.setState({
          isCardReaderConnected: false,
          cardReaderConnectError: discoverResult.error.message,
        });
      } else if (discoverResult.discoveredReaders.length === 0) {
        self.setState({
          noDevice: true,
        });
        console.log("No available readers.");
        self.setState({
          selectedCardReader: {},
          isCardReaderConnected: false,
          cardReaderConnectError: "No available readers",
        });
      } else {
        console.log("selectedCardReader", self.state.selectedCardReader);
        console.log(
          "discoveredReaders[0]",
          discoverResult.discoveredReaders[0]
        );
        let result = _.find(discoverResult.discoveredReaders, function (obj) {
          if (
            obj.serial_number === self.state.selectedCardReader.serial_number
          ) {
            return true;
          }
        });
        console.log("finalselectedCardReader", result);
        if (result) {
          self.connectReader(result);
        } else {
          self.connectReader(discoverResult.discoveredReaders[0]);
        }
        self.setState({
          discoverResult: discoverResult.discoveredReaders,
          cardReaderConnectError:"",
          payoutError:""
        });
      }
    });
  };

  connectReader = async (selectedReader) => {
    console.log("connect card reader function");
    let self = this;

    await terminal.disconnectReader();
    terminal.connectReader(selectedReader).then(function (connectResult) {
      if (connectResult.error) {
        self.setState({
          isCardReaderConnected: false,
          cardReaderConnectError: connectResult.error.message,
        });
      } else {
        //self.cardReaderList();
        self.setState({
          isCardReaderConnected: true,
          isShowConnectionLoader: false,
          cardReaderConnectError:"",
          payoutError:""
        });
      }
    });
  };

  processPayment = (paymentIntent) => {
    // transactions
    let self = this;
    terminal.processPayment(paymentIntent).then(function (result) {
      if (result.error) {
        self.setState({
          isCheckoutPayment: false,
          payoutError: result.error.message0,
        });
      } else if (result.paymentIntent) {
        let filteredProduct = [];
        let filteredService = [];
      
        //   _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
        //   if(_checkOutSelectedItem?.type==='product'){
        //     filteredProduct.push(_checkOutSelectedItem?._id)
        //   }else{
        //     filteredService.push(_checkOutSelectedItem?.selectedService?.serviceId)
        //   }
        // })

        // IMPORTANT: Do NOT include voucher SALES in voucherIds for paymentIntentsCapture
        // voucherIds should ONLY contain vouchers being REDEEMED (used as payment)
        // Voucher SALES are already in the booking's vouchers array from createBooking
        // Only extract voucher REDEMPTIONS from the transaction array
        let voucherRedemptions = [];
        if (self.state.transaction && self.state.transaction.length > 0) {
          voucherRedemptions = self.state.transaction
            .filter(t => t.paymentType === 11 && t.voucherId && t.voucherCode)
            .map(t => ({
              id: t.voucherId,
              value: parseFloat(t.amount || 0),
              code: t.voucherCode
            }));
        }
        
        _.forEach(self?.state?.checkoutSelectedItems, (_checkOutSelectedItem,i)=>{
          if(_checkOutSelectedItem?.type==='product'){
            filteredProduct.push({..._checkOutSelectedItem,id:_checkOutSelectedItem?._id,retailPrice:parseFloat(_checkOutSelectedItem?.retailPrice)})
          } else if(_checkOutSelectedItem?.type==='voucher'){
            // Voucher SALES are already in the booking from createBooking
            // Do NOT send them to paymentIntentsCapture as voucherIds
            console.log('Voucher SALE detected in cart (will NOT be sent as voucherId to capture):', _checkOutSelectedItem);
          } else{
            filteredService.push({id:_checkOutSelectedItem?.selectedService?.serviceId,price:_checkOutSelectedItem?.selectedService?.servicePrice});
          }
        })

   
        self.props
          .dispatch(
            paymentActions.paymentIntentsCapture({
              bookingId: self.state.bookingId,
              paymentIntentId: result.paymentIntent.id,
              servicesToBook:filteredService,
              productIds:filteredProduct,
              voucherIds: voucherRedemptions, // ONLY send voucher REDEMPTIONS, NOT sales
              selectedPaymentType: 5 // Always 5 for Beu card reader payments
            })
          )

          .then(function (response) {
            if(response.data.statusCode===0){
              if( response?.data?.error?.errorCode===10 || response?.data?.error?.errorCode===5 ){
                if(response.data.error.errors.errorCode){
                  self.setState({
                    isCheckoutPayment: false,
                    isCardReaderConnected:false,
                  },()=>{
                    toast.error(response?.data?.error?.errors?.responseMessage);
                  })

                }else{
                  self.setState({
                    isCheckoutPayment: false,
                    isCardReaderConnected:false,
                  },()=>{
                    toast.error(response.data.error.responseMessage);
                  })

                }
                // setTimeout(()=>{
                //   window.location.reload();
                // },4000)
              }
            }
            let _tipAmount =
              response.data?.responseData.result.tipAmount != undefined
                ? response.data?.responseData.result.tipAmount
                : 0;
            if (response.data.statusCode === 1) {
              // Check if there are any voucher transactions in the transaction list
              const voucherTransactions = self.state.transaction.filter(
                (transaction) => transaction.paymentType === 11 && transaction.voucherId
              );
              
              // If there are voucher transactions, finalize them
              if (voucherTransactions.length > 0) {
                console.log('Finalizing voucher transactions:', voucherTransactions);
                
                // Process each voucher transaction
                const voucherPromises = voucherTransactions.map(transaction => {
                  // Get the current voucher from the API to get its current balance
                  return self.props.dispatch(voucherActions.getVoucherByCode(transaction.voucherCode))
                    .then(voucherResponse => {
                      if (voucherResponse.data && voucherResponse.data.statusCode === 1 && voucherResponse.data.responseData.data) {
                        const voucher = voucherResponse.data.responseData.data;
                        
                        // The voucher balance was already updated when the voucher was applied,
                        // but we need to ensure it's correctly recorded in the booking
                        console.log('Voucher transaction finalized for code:', transaction.voucherCode);
                        return Promise.resolve();
                      } else {
                        console.error('Error getting voucher for finalization:', transaction.voucherCode);
                        return Promise.reject('Error getting voucher');
                      }
                    })
                    .catch(error => {
                      console.error('Error finalizing voucher transaction:', error);
                      return Promise.reject(error);
                    });
                });
                
                // Wait for all voucher transactions to be finalized
                Promise.all(voucherPromises)
                  .then(() => {
                    self.setState({
                      isPaymentComplete: 1,
                      isCheckoutPayment: false,
                      tipAmount: _tipAmount,
                    });
                  })
                  .catch(error => {
                    console.error('Error finalizing voucher transactions:', error);
                    self.setState({
                      isPaymentComplete: 1,
                      isCheckoutPayment: false,
                      tipAmount: _tipAmount,
                    });
                  });
              } else {
                // No voucher transactions, just update the state
                self.setState({
                  isPaymentComplete: 1,
                  isCheckoutPayment: false,
                  tipAmount: _tipAmount,
                });
              }
            }
          });
      }
    });
  };

  addStripeTerminal = () => {
    let self = this;
    self.props
      .dispatch(
        paymentActions.addTerminal({
          registrationCode: this.state.registrationCode,
          label: this.state.label,
        })
      )
      .then(function (response) {
        if (response.data.statusCode === 1) {
          self.cardReaderList();
          self.handleClose();
        } else {
          //setCardReaderConnectError(response.data.error.responseMessage)
        }
      });
  };

 addCheckoutItem(type){
  let self = this;
  let dispatch = self.props?.dispatch;
  let filterData = self.state.checkoutSelectedItems.filter(item=>(typeof item.id!=='string'));
  let lastIndex = filterData.length + 1;
  
  // Update the location state with the new item type
  if (self.props.history && self.props.history.location) {
    const currentState = self.props.history.location.state || {};
    
    // Set the itemType in the state to the new type
    const updatedState = {
      ...currentState,
      itemType: type
    };
    
    // Update the history state with the new itemType
    self.props.history.replace({
      pathname: self.props.history.location.pathname,
      state: updatedState
    });
    
    console.log(`Updated itemType in location state to '${type}' when adding new item`);
  }
  
  if(type==='product'){
    const newProduct = {
      id: lastIndex,
      type:"product",
      selectedStaff:null
    };

    dispatch(productAction.selectCheckoutItem({}));
    if(filterData?.length==0){
      self.setState({
        selectedStaff:null,
        selectedClient: siteSetting.noClientDAta,
      })
    }

    let productData = [...filterData, newProduct];
    self.setState({
      checkoutSelectedItems:productData,
    },()=>{
      dispatch(productAction?.selectedCheckoutList(productData));
      self.calculateCheckoutItem();
    });
  } else if(type==='voucher'){
    const newVoucher = {
      id: lastIndex,
      type:"voucher",
      selectedStaff:null
    };

    dispatch(productAction.selectCheckoutItem({}));
    if(filterData?.length==0){
      self.setState({
        selectedStaff:null,
        selectedClient: siteSetting.noClientDAta,
      })
    }

    let voucherData = [...filterData, newVoucher];
    self.setState({
      checkoutSelectedItems:voucherData,
    },()=>{
      dispatch(productAction?.selectedCheckoutList(voucherData));
      self.calculateCheckoutItem();
    });
  } else {
    const newService = {
      id: lastIndex,
      type:"service",
      selectedStaff:null
    };

    if(filterData?.length==0){
      self.setState({
        selectedStaff:null,
        selectedClient: siteSetting.noClientDAta,
      })
    }
    
    let serviceData = [...filterData, newService];
    dispatch(productAction?.selectedCheckoutList(serviceData));
    self.setState({
      checkoutSelectedItems:serviceData,
    }, () => {
      self.calculateCheckoutItem();
    });
  }
 }

 removeCheckoutItem = (type, selectedItemId) => {
  let self = this;
  let dispatch = self.props?.dispatch;
  
  if (type === 'product' || type === 'service' || type === 'voucher') {
    // Find the item being removed
    const itemToRemove = self.state.checkoutSelectedItems?.find(item => item?.id === selectedItemId);
    
    // Filter out the item from the list
    let updatedList = self.state.checkoutSelectedItems?.filter(item => item?.id !== selectedItemId);
    dispatch(productAction?.selectedCheckoutList(updatedList));
    
    // If it's a voucher, call the API to restore its value
    if (type === 'voucher' && itemToRemove) {
      console.log('Restoring voucher value for:', itemToRemove);
      
      // Check if we have the voucher ID
      if (itemToRemove.voucherId) {
        // Call the voidVoucher action to restore the voucher's value
        dispatch(voucherActions.voidVoucher(itemToRemove.voucherId))
          .then(response => {
            console.log('Voucher value restored successfully:', response);
            toast.success('Voucher value restored successfully');
          })
          .catch(error => {
            console.error('Error restoring voucher value:', error);
            toast.error('Error restoring voucher value');
          });
      } else if (itemToRemove.voucherCode) {
        // If we don't have the voucher ID but have the code, try to get the voucher by code first
        dispatch(voucherActions.getVoucherByCode(itemToRemove.voucherCode))
          .then(response => {
            if (response.data && response.data.data && response.data.data.id) {
              // Now void the voucher
              dispatch(voucherActions.voidVoucher(response.data.data.id))
                .then(voidResponse => {
                  console.log('Voucher value restored successfully:', voidResponse);
                  toast.success('Voucher value restored successfully');
                })
                .catch(error => {
                  console.error('Error restoring voucher value:', error);
                  toast.error('Error restoring voucher value');
                });
            }
          })
          .catch(error => {
            console.error('Error getting voucher by code:', error);
            toast.error('Error restoring voucher value');
          });
      }
    }
    
    // Update state and recalculate
    self.setState({
      checkoutSelectedItems: updatedList
    }, () => {
      // Clear any stored item type information in the location state
      if (self.props.history && self.props.history.location && self.props.history.location.state) {
        const currentState = { ...self.props.history.location.state };
        
        // Remove the itemType from the state to prevent it from persisting
        if (currentState.itemType) {
          delete currentState.itemType;
          
          // Update the history state without the itemType
          self.props.history.replace({
            pathname: self.props.history.location.pathname,
            state: currentState
          });
          
          console.log('Cleared itemType from location state after item removal');
        }
      }
      
      self.calculateCheckoutItem();
    });
  }
 }

  staffMemberHandler(name) {
    this.setState({
      hairDresserName: name,
    });
  }

  onSelectStaff = (type,staffRecord,indexId) =>{
    let self = this;
    let dispatch = self.props?.dispatch;
     if(type==='product' || type==='service' || type==='voucher'){
      let _hairdresserId = staffRecord?.value!==undefined?staffRecord?.selectedStaff?.value:'';
        const checkOutItem = {
          id: 1,
          type:type,
          selectedStaff:staffRecord
        };
        let serviceData = [checkOutItem];
        dispatch(bookingActions?.hairdresserNewBookingStaff({_id:staffRecord?.value,name:staffRecord?.label}));
        dispatch(productAction?.selectedCheckoutList(serviceData));
        self.setState({
          checkoutSelectedItems:serviceData,
          hairdresserId:_hairdresserId,
          selectedStaff:staffRecord
        }, () => {
          self.calculateCheckoutItem();
        });
     }
  }

  changeItemPrice(_item,type,price,err){
    let self = this;
    let  priceStatusCount = 0;
    
    console.log('changeItemPrice - item:', _item);
    console.log('changeItemPrice - type:', type);
    console.log('changeItemPrice - price:', price);
    
    self.setState({
      priceError:err
     });
    if(type==='service'){
    let updatedPriceData = self.props.selectedCheckoutList.map((_serviceData)=>{
       if(_serviceData.selectedService?.indexId===_item?.selectedService?.indexId){
         _serviceData.selectedService.servicePrice =parseFloat(price);
       }
       return _serviceData;
      })

      let totalAmount = updatedPriceData.reduce((prev,curr)=>{
             if(curr?.selectedService?.retailPrice==='' || curr?.selectedService?.servicePrice===''){
               priceStatusCount++
             }
              if(curr?.selectedService?.servicePrice!==undefined){
               prev= prev+ parseFloat(curr?.selectedService?.servicePrice===''?0:curr?.selectedService?.servicePrice);
               return prev;
              }else{
               prev= prev+ parseFloat(curr?.retailPrice===''?0:curr?.retailPrice);
               return prev;
              }
      },0);

      self.setState({
       totalAmount:totalAmount,
       pendingAmount:totalAmount,
       priceErrorStatus:priceStatusCount>0?false:true,
       selectedTotalAmount:totalAmount
      })
      self.props.dispatch(productAction?.selectedCheckoutList(updatedPriceData));
    } else if(type==='voucher'){
      let updatedPriceData = self.props.selectedCheckoutList.map((_voucherData)=>{
        if(_voucherData?.id===_item?.id){
          _voucherData.voucherPrice = parseFloat(price);
        }
        return _voucherData;
      });
      
      console.log('changeItemPrice - updatedPriceData for voucher:', updatedPriceData);

      let totalAmount = updatedPriceData.reduce((prev,curr)=>{
        if(curr?.voucherPrice==='' || curr?.voucherPrice===undefined){
          priceStatusCount++;
        }
        
        if(curr?.type==='voucher' && curr?.voucherPrice!==undefined){
          prev = prev + parseFloat(curr?.voucherPrice===''?0:curr?.voucherPrice);
          return prev;
        } else if(curr?.retailPrice!==undefined){
          prev = prev + parseFloat(curr?.retailPrice===''?0:curr?.retailPrice);
          return prev;
        } else if(curr?.selectedService?.servicePrice!==undefined){
          prev = prev + parseFloat(curr?.selectedService?.servicePrice===''?0:curr?.selectedService?.servicePrice);
          return prev;
        } else {
          return prev;
        }
      },0);
      
      self.setState({
        totalAmount:totalAmount,
        pendingAmount:totalAmount,
        priceErrorStatus:priceStatusCount>0?false:true,
        selectedTotalAmount:totalAmount
      });
      
      self.props.dispatch(productAction?.selectedCheckoutList(updatedPriceData));
    } else {
     let updatedPriceData = self.props.selectedCheckoutList.map((_serviceData)=>{
       if(_serviceData?.id===_item?.id){
         _serviceData.retailPrice =parseFloat(price)
       }
       return _serviceData;
      })

      let totalAmount = updatedPriceData.reduce((prev,curr)=>{

       if(curr?.retailPrice==='' || curr?.servicePrice===''){
         priceStatusCount++
       }

       if(curr?.retailPrice!==undefined){
         prev= prev+ parseFloat(curr?.retailPrice===''?0:curr?.retailPrice);
         return prev;
       }else{
         prev= prev+ parseFloat(curr?.selectedService?.servicePrice===''?0:curr?.selectedService?.servicePrice);
         return prev;
       }
      },0);

      self.setState({
       totalAmount:totalAmount,
       pendingAmount:totalAmount,
       priceErrorStatus:priceStatusCount>0?false:true,
       selectedTotalAmount:totalAmount
      })

      self.props.dispatch(productAction?.selectedCheckoutList(updatedPriceData));
    }
 }

 updateNewEditAmount(){
  let self = this;
  let params = {};
  params.hairdresserId = self.state.hairdresserId;
  params.salonId = self.state.salonId;
  params.bookingId = self.state.bookingId;
  params.services = _.map(this.state.selectedService, function (o) {
    return {id:o?.service?.serviceId!=undefined?o?.service?.serviceId:o?.serviceId, price:parseFloat(o?.service?.servicePrice!=undefined?o?.servicePrice:o?.service?.servicePrice)};
  });
  params.products = _.map(this.state.productList, function (o) {
    return {...o,id:o._id,retailPrice:parseFloat(o?.retailPrice)};
  });
  params.vouchers = _.map(this.state.voucherList || [], function (o) {
    return {...o,id:o._id,voucherPrice:parseFloat(o?.voucherPrice || 0)};
  });
  
  console.log('updateNewEditAmount - params:', params);

  return self.props.dispatch(bookingActions?.editProductServiceBooking(params))

 }

  render() {
   console.log("this.props",this.props);
    console.log("this.state",this.state);
    return (
      <div>
        <div className="h_n">
          <div className="body_container cm_bg_white">
            <TopHeader title="Checkout"
            headerButtonStatus={true}
            cancelButton={true}
            {...this.props} />
             {/* <BookingNavigation data={this.props} bookingUrl={`/newBooking/${this.props.match.params.salonId}`} {...this.props}/> */}
            <div className="service_flex_div new__checkout_page service_flex__space">
              <div
                className={
                  this.state.isInvoice === 0
                    ? "main_service_div"
                    : "main_service_div"
                }
              >
              {console.log('check the data', {
                firstItem: this.props.selectedCheckoutList[0],
                isProduct: this.props.selectedCheckoutList[0]?.type=='product' && this.props.selectedCheckoutList[0]?._id!=undefined,
                isService: this.props.selectedCheckoutList[0]?.selectedService?._id!=undefined && this.props.selectedCheckoutList[0]?.type=='service',
                isVoucher: this.props.selectedCheckoutList[0]?.type=='voucher' && this.props.selectedCheckoutList[0]?._id!=undefined,
                showCheckout: ((this.props.selectedCheckoutList[0]?.type=='product'&&this.props.selectedCheckoutList[0]?._id!=undefined)||
                  (this.props.selectedCheckoutList[0]?.selectedService?._id!=undefined && this.props.selectedCheckoutList[0]?.type=='service')||
                  (this.props.selectedCheckoutList[0]?.type=='voucher'&&this.props.selectedCheckoutList[0]?._id!=undefined))
              })}
              {this.props.selectedCheckoutList?.length > 0
                       ? this.props.selectedCheckoutList.map((item, i) => (
                           item?.type==='service' ? <CheckoutService
                             key={"service_" + i}
                             item={item}
                             index={i+1}
                             removeService={this.removeCheckoutItem}
                             propData={this.props}
                             staffList={this.state.staffList}
                             onSelectStaff={this.onSelectStaff}
                             selectedStaff={this.state.selectedStaff}
                             selectedClient={this.state.selectedClient}
                             isPaymentComplete={this.state.isPaymentComplete}
                             changeItemPrice={this.changeItemPrice}
                             finalBookingSlots={this?.state?.finalBookingSlots}
                             currencySymbol={this.state.currencySymbol}
                           /> : item?.type==='product' ? <CheckoutProduct
                           index={i+1}
                           key={"products_" + i}
                           item={item}
                           hairdresserName={this.state.hairdresserName}
                          removeProduct={this.removeCheckoutItem}
                          handleClickProduct={this.handleClickProduct}
                          staffList={this.state.staffList}
                          propData={this.props}
                          onSelectStaff={this.onSelectStaff}
                          selectedStaff={this.state.selectedStaff}
                          selectedClient={this.state.selectedClient}
                          isPaymentComplete={this.state.isPaymentComplete}
                          changeItemPrice={this.changeItemPrice}
                          finalBookingSlots={this?.state?.finalBookingSlots}
                          currencySymbol={this.state.currencySymbol}
                        /> : <CheckoutVoucher
                          index={i+1}
                          key={"voucher_" + i}
                          item={item}
                          removeVoucher={this.removeCheckoutItem}
                          propData={this.props}
                          staffList={this.state.staffList}
                          onSelectStaff={this.onSelectStaff}
                          selectedStaff={this.state.selectedStaff}
                          selectedClient={this.state.selectedClient}
                          isPaymentComplete={this.state.isPaymentComplete}
                          changeItemPrice={this.changeItemPrice}
                          currencySymbol={this.state.currencySymbol}
                        />
                        ))
                      : null}
               
                  {this.state.isPaymentComplete===1?null:<div className="row">
                    <div className="col-md-11">
                   
                      <div className="button-group-service">
                      {this?.state?.priceError==''?<button className="btn btn-default bg-light text-dark"
                      onClick={()=>this.addCheckoutItem('service')} > Add Service </button>
                      :<button className="btn btn-default bg-light text-dark cursor-notAllow" > Add Service </button>
                      }
                        
                  {this?.state?.priceError==''?<button
                  className="btn btn-default bg-light text-dark"
                  onClick={()=>this.addCheckoutItem('product')}
                >
                  Add Product
                </button>:<button
                className="btn btn-default bg-light text-dark cursor-notAllow"
              >
                Add Product
              </button>}

              {this?.state?.priceError==''?<button
                  className="btn btn-default bg-light text-dark"
                  onClick={()=>this.addCheckoutItem('voucher')}
                >
                  Add Voucher
                </button>:<button
                className="btn btn-default bg-light text-dark cursor-notAllow"
              >
                Add Voucher
              </button>}
                       
                     </div>
                    </div>
                  </div>}
              </div>
              
              {((this.props.selectedCheckoutList[0]?.type=='product'&&this.props.selectedCheckoutList[0]?._id!=undefined)||
                (this.props.selectedCheckoutList[0]?.selectedService?._id!=undefined && this.props.selectedCheckoutList[0]?.type=='service')||
                (this.props.selectedCheckoutList[0]?.type=='voucher'&&this.props.selectedCheckoutList[0]?._id!=undefined))?(<>
                <div
                className={"checkout_page"}
              >
                {/* Find Voucher Modal */}
                <FindVoucherModal
                  show={this.state.showFindVoucherModal}
                  onHide={this.closeFindVoucherModal}
                  onFind={this.findVoucher}
                />
                
                {/* Redeem Voucher Modal */}
                <RedeemVoucherModal
                  show={this.state.showRedeemVoucherModal}
                  onHide={this.closeRedeemVoucherModal}
                  voucher={this.state.foundVoucher}
                  onRedeem={this.redeemVoucher}
                  user={this.props.user}
                  pendingAmount={this.state.pendingAmount}
                />
                
                {/* Payment Link Modal */}
                <PaymentLinkModal
                  show={this.state.showPaymentLinkModal}
                  onHide={() => this.setState({ showPaymentLinkModal: false, paymentLinkData: null })}
                  paymentLinkData={this.state.paymentLinkData}
                  bookingId={this.state.bookingId}
                  onPaymentComplete={this.handlePaymentComplete}
                  onCheckPayment={this.checkPaymentStatus}
                  clientEmail={this.state.selectedClient?.email || ''}
                  clientName={this.state.selectedClient?.name || this.state.selectedClient?.firstName || ''}
                />
                
              {this?.state?.priceError!=''?<div className="overlay-wrapper-checkout"></div>:null}
                   <Checkout
                      checkCompleteSale={this.checkCompleteSale}
                      removeTransaction={this.removeTransaction}
                      selectBookingAmount={this.selectBookingAmount}
                      bookingState={{
                        ...this.state,
                        pendingAmount: this.state.pendingAmount,
                      }}
                      setPaymentType={this.setPaymentType}
                      saveBooking={this.saveBooking}
                      onChangedValue={this.onChanged}
                      pendingAmount={this.state.selectedTotalAmount}
                      currencySymbol={this.state.currencySymbol}
                      paymentAmountError={this.state.paymentAmountError}
                      selectedClient={this.state.selectedClient}
                      selectedService={this.state.selectedService}
                      totalAmount={this.state.selectedTotalAmount}
                      paymentType={this.state.paymentType}
                      resetBooking={this.resetBooking}
                      paymentAmount={this.state.selectedTotalAmount}
                      completeSale={this.completeSale}
                      hairdresserId={this.state.hairdresserId}
                      bookings={
                        this.props?.hairdresserBooking?.bookings &&
                        this.props?.hairdresserBooking?.bookings[0]
                      }
                      cardReaderList={this.props.cardReaderList}
                      setPaymentCardReader={this.setPaymentCardReader}
                      checkout={this.checkout}
                      selectedStaff={this.state.selectedStaff}
                      addStripeTerminal={this.addStripeTerminal}
                      handleClose={this.handleClose}
                      handleDiscoverModal={this.handleDiscoverModal}
                      openFindVoucherModal={this.openFindVoucherModal}
                      hidePaymentLinkOptions={false}
                      paymentMethods={this.state.paymentMethods}
                    />
               
              </div></>):null}
            </div>
            {/* <div className="cm_loader"><div className="loader"></div></div> */}
            <br></br>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(InstantCheckout);
